try {
document.addEventListener('DOMContentLoaded', async function() {
  // =========================================================
  // CONFIGURATION (fetch from server using metafield)
  // =========================================================
  const config = window.pcConfig || {};
  let views = [];
  let configFetchPromise = null;

  /** Same rule as generateLogos / generateTexts (mobileScaleFactor). Sent to the quote API so server renders match the preview. */
  function getViewportMobileScaleForApi() {
    return window.innerWidth < 768 ? 0.75 : 1;
  }
  
  // Fetch config from API if customiser_id exists (check for empty string too)
  const customiserId = config.customiserId ? String(config.customiserId).trim() : '';
  const isPurchaseBagMode = !!(window && window.pcPurchaseBagMode);
  if (customiserId) {
    const loadCustomizerConfig = async () => {
      const base = String(config.customizerApiUrl || 'https://rogue-wear-shopify-quote-api-v4.vercel.app').replace(/\/$/, '');
      // Add cache-busting timestamp to ensure fresh data
      const cacheBuster = '&_t=' + Date.now();
      const res = await fetch(base + '/api/customizer-config?customizer_id=' + encodeURIComponent(customiserId) + cacheBuster, {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      const data = await res.json().catch(function() { return {}; });
      return data;
    };

    if (isPurchaseBagMode) {
      // Don't block the product page UI: show "Start Customizing" immediately,
      // but delay modal initialization until the config promise resolves.
      configFetchPromise = loadCustomizerConfig()
        .then((data) => {
          views = data.views || [];
          config.views = views;
          // Enable CTA now that config is ready (prevents "Loading Customizer..." timeout)
          try {
            const inline = document.getElementById('pc-trigger-btn-inline');
            if (inline) {
              inline.disabled = false;
              inline.style.opacity = '1';
              inline.style.pointerEvents = '';
              inline.style.cursor = '';
              inline.style.filter = '';
            }
            const loading = document.getElementById('pc-trigger-btn-loading');
            if (loading) loading.style.display = 'none';
          } catch (e) {}
          return views;
        })
        .catch((e) => {
          console.error('[Customizer] Failed to fetch customizer config:', e);
          views = [];
          config.views = [];
          return [];
        });
    } else {
      try {
        const data = await loadCustomizerConfig();
        views = data.views || [];
        config.views = views;
      } catch (e) {
        console.error('[Customizer] Failed to fetch customizer config:', e);
        views = [];
        config.views = [];
      }
    }
  }
  
  // Show/hide button based on whether we have views
  // Button is rendered in buy_buttons block, we just control its visibility
  // Get button references in broader scope so they can be used later
  const inlineBtn = document.getElementById('pc-trigger-btn-inline');
  const loadingBtn = document.getElementById('pc-trigger-btn-loading');
  
  // Function to swap loading button with actual button
  function swapToReadyButton() {
    if (loadingBtn && inlineBtn) {
      // Hide loading button
      loadingBtn.style.display = 'none';
      // Show actual button with smooth transition
      inlineBtn.style.display = 'block';
      inlineBtn.disabled = false;
      inlineBtn.style.opacity = '0';
      inlineBtn.style.transition = 'opacity 0.3s ease';
      // Trigger fade-in
      setTimeout(() => {
        inlineBtn.style.opacity = '1';
      }, 10);
    } else if (inlineBtn) {
      // If no loading button, just show the actual button
      inlineBtn.style.display = 'block';
      inlineBtn.disabled = false;
    }
  }

  // In purchase-bag mode, show the CTA immediately (config fetch runs in background).
  if (isPurchaseBagMode) {
    // Purchase-bag: show CTA immediately; modal init will wait for config promise.
    swapToReadyButton();
  }
  
  // Function to hide both buttons (if no customizer)
  function hideAllButtons() {
    if (loadingBtn) loadingBtn.style.display = 'none';
    if (inlineBtn) inlineBtn.style.display = 'none';
  }
  
  // Use a function to ensure button visibility is set even if later code fails
  function updateButtonVisibility(customiserIdValue, viewsArray) {
    let shouldContinue = false;
    let reason = 'unknown';

    // Check if customiserId exists and is not empty/whitespace
    if (!customiserIdValue) {
      reason = 'no-customiser-id';
      hideAllButtons();
      shouldContinue = false;
    } else if (!viewsArray || viewsArray.length === 0) {
      reason = 'no-views';
      hideAllButtons();
      shouldContinue = false;
    } else {
      // Swap loading button to ready button
      reason = 'views-loaded';
      swapToReadyButton();
      shouldContinue = true;
    }

    return shouldContinue;
  }
  
  // Update button visibility immediately
  // In purchase-bag mode we don't block the JS from running if `views` is still loading.
  if (!isPurchaseBagMode) {
    const shouldContinue = updateButtonVisibility(customiserId, views);
    if (!shouldContinue) {
      return; // Exit early if no customizer
    }
  }

  const BRAND_COLORS = [
    { name: 'Black', hex: '#363636' },
    { name: 'White', hex: '#FFFFFF' },
    { name: 'Silver Gray', hex: '#E0E0E0' },
    { name: 'Steel Gray', hex: '#7a7a7a' },
    { name: 'Royal', hex: '#0033CC' },
    { name: 'Navy', hex: '#000055' },
    { name: 'Columbia', hex: '#9AC0FF' },
    { name: 'Purple', hex: '#4f2684' },
    { name: 'Forest', hex: '#006633' },
    { name: 'Moss Navy', hex: '#6d7042' },
    { name: 'Kelly', hex: '#009933' },
    { name: 'Gold', hex: '#ffc630' },
    { name: 'Maroon', hex: '#800000' },
    { name: 'Red', hex: '#CC0000' },
    { name: 'Orange', hex: '#FF6B00' },
    { name: 'Vegas Gold', hex: '#F5E6A3' }
  ];

  /** Explicit MIME + extensions: Safari/iOS often omit SVG (and sometimes WebP) when using accept="image/*" alone. */
  const LOGO_IMAGE_ACCEPT = [
    'image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif', 'image/bmp',
    'image/x-ms-bmp', 'image/tiff', 'image/x-icon', 'image/svg+xml',
    'image/avif', 'image/heic', 'image/heif',
    '.png', '.jpg', '.jpeg', '.webp', '.gif', '.bmp', '.tif', '.tiff', '.svg', '.ico', '.avif', '.heic', '.heif'
  ].join(',');

  function isAllowedLogoImageFile(file) {
    if (!file || typeof file !== 'object') return false;
    const t = (file.type || '').toLowerCase();
    if (/^image\/(png|jpeg|jpg|gif|webp|avif|bmp|svg\+xml|x-ms-bmp|tiff?|x-icon|heic|heif|vnd\.microsoft\.icon)$/i.test(t)) {
      return true;
    }
    const n = (file.name || '').toLowerCase();
    return /\.(png|jpe?g|gif|webp|avif|bmp|tiff?|svg|ico|heic|heif)$/i.test(n);
  }

  // Layer utilities
  function isLayerColorLocked(layer) {
    return !!(layer && (layer.lockColor || layer.linkedTextKey));
  }

  function isLogoLayerByName(layer) {
    const name = (layer?.name || '').toString();
    return /logo/i.test(name);
  }

  function isAnyTextLinkedToLayer(view, layerId) {
    if (!view || !layerId) return false;
    return !!(
      view?.text1?.linkedLayerId === layerId ||
      view?.text2?.linkedLayerId === layerId ||
      view?.logoOrText?.linkedLayerId === layerId
    );
  }

  function getLayerBaseColor(layer) {
    if (!layer) return '#E0E0E0';
    const fallback = '#E0E0E0'; // Silver Gray in BRAND_COLORS
    const raw = (layer.defaultColor || fallback).toString().trim().toUpperCase();
    // If the default isn't part of our palette, fall back to Silver Gray so UI doesn't show "Unknown".
    const inPalette = Array.isArray(BRAND_COLORS) && BRAND_COLORS.some(c => String(c?.hex || '').toUpperCase() === raw);
    return inPalette ? raw : fallback;
  }

  // Initial color for a layer when (re)building state
  function getLayerInitialColor(layer) {
    // For now, locked layers use the same default color; this helper
    // exists so we can extend behavior later without touching callers.
    if (layer && layer.linkedTextKey) {
      // In standard mode, allow layer color to follow a text color.
      // The actual value is synced when controls initialize; use default as fallback.
      return layer.defaultColor || '#E0E0E0';
    }
    return getLayerBaseColor(layer);
  }

  function getLinkedTextColorForLayer(view, layer) {
    if (!view || !layer?.linkedTextKey) return null;
    const key = String(layer.linkedTextKey);
    if (key === 'text1') return view?.elements?.text1?.color || view?.text1?.defaultColor || null;
    if (key === 'text2') return view?.elements?.text2?.color || view?.text2?.defaultColor || null;
    if (key === 'logoOrText') return view?.elements?.logoOrText?.color || view?.logoOrText?.defaultColor || null;
    return null;
  }

  function syncLayersLinkedToTextColors(view) {
    if (!view?.layers?.length) return;
    view.layers.forEach((layer) => {
      if (!layer?.linkedTextKey) return;
      const c = getLinkedTextColorForLayer(view, layer);
      if (!c) return;
      view.parts[layer.id] = c;
      updateLayerVisuals(view.id, layer.id, c);
    });
  }

  // =========================================================
  // Purchase-bag mode (variant-driven locked bag colors)
  // =========================================================
  const isPurchaseBag = window.pcPurchaseBagMode === true;
  const PURCHASE_BAG_BLACK_HEX = '#363636';
  const PURCHASE_BAG_WHITE_HEX = '#FFFFFF';
  const DEFAULT_PURCHASE_BAG_MAX_LETTERING_FEES = 5;

  function normalizeColorName(name) {
    return (name ?? '').toString().trim().toLowerCase();
  }

  function getBrandColorHexByNameCI(name) {
    const target = normalizeColorName(name);
    if (!target) return null;
    const aliases = {
      steel: 'steel gray',
      silver: 'silver gray',
      grey: 'silver gray'
    };
    const canonical = aliases[target] || target;
    let match = BRAND_COLORS.find((c) => normalizeColorName(c.name) === canonical);
    if (!match) {
      // Handle option labels that are shorter than palette labels (e.g. "Steel" vs "Steel Gray").
      match = BRAND_COLORS.find((c) => {
        const colorName = normalizeColorName(c.name);
        return colorName.includes(canonical) || canonical.includes(colorName);
      });
    }
    return match ? match.hex : null;
  }

  function getPurchaseBagBodyHexFromVariant(variant) {
    if (!variant) return PURCHASE_BAG_BLACK_HEX;
    const optionValues = ['option1', 'option2', 'option3']
      .map((key) => variant[key])
      .filter((v) => v !== undefined && v !== null && String(v).trim() !== '');

    let matchedOption = null;
    for (const opt of optionValues) {
      const hex = getBrandColorHexByNameCI(opt);
      if (hex) {
        matchedOption = opt;
        return hex;
      }
    }

    // Fallback if variant option doesn't match any BRAND_COLORS by name
    return PURCHASE_BAG_BLACK_HEX;
  }

  function isPurchaseBagLogoLayer(layer) {
    const layerName = (layer?.name || '').toString();
    return /logo/i.test(layerName);
  }

  function getPurchaseBagLockedLayerColor(layer, idx, bodyHex) {
    if (idx === 0) return bodyHex;
    return isPurchaseBagLogoLayer(layer) ? PURCHASE_BAG_WHITE_HEX : PURCHASE_BAG_BLACK_HEX;
  }

  function getLockedTextValue(textConfig) {
    if (!textConfig) return '';
    if (typeof textConfig.lockedContent === 'string') return textConfig.lockedContent;
    if (typeof textConfig.defaultContent === 'string') return textConfig.defaultContent;
    return '';
  }

  function isTextContentLocked(textConfig) {
    // Treat lockedContent as a "lock" only when it has a non-empty value.
    // Some builder configs may include lockedContent: '' by default; that should NOT lock the field.
    const lockedStr = (textConfig && typeof textConfig.lockedContent === 'string') ? textConfig.lockedContent : null;
    const hasLockedString = typeof lockedStr === 'string' && lockedStr.trim() !== '';
    return !!(textConfig && (textConfig.lockContent === true || hasLockedString));
  }

  function enforceLockedTextContent(view) {
    if (!view || !view.elements) return;

    [view.text1, view.text2].forEach((textConfig, idx) => {
      const textNum = idx + 1;
      if (!textConfig || textConfig.enabled === false) return;
      if (!isTextContentLocked(textConfig)) return;

      const locked = getLockedTextValue(textConfig);
      const textState = view.elements[`text${textNum}`];
      if (!textState) return;

      textState.content = locked;
      textState.active = String(locked).trim() !== '';
    });
  }

  function shouldRequirePaidTextOptIn(textConfig) {
    return !!(isPurchaseBag && textConfig && textConfig.enabled !== false && !isTextContentLocked(textConfig));
  }

  function ensurePaidTextOptInState(view, textNum) {
    const textState = view?.elements?.[`text${textNum}`];
    if (!textState) return false;
    if (typeof textState.paidOptIn !== 'boolean') {
      textState.paidOptIn = false;
    }
    return textState.paidOptIn;
  }

  function getPurchaseBagMaxLetteringFees() {
    const raw = Number(window.pcPurchaseBagMaxLetteringFees);
    if (!Number.isFinite(raw)) return DEFAULT_PURCHASE_BAG_MAX_LETTERING_FEES;
    const normalized = Math.floor(raw);
    if (normalized < 0) return 0;
    return normalized;
  }

  function getCurrentLetteringCountPerBag() {
    let letteringCount = 0;
    state.views.forEach((viewState) => {
      const text1Config = viewState?.text1 || null;
      const text2Config = viewState?.text2 || null;
      if (shouldRequirePaidTextOptIn(text1Config) && viewState?.elements?.text1?.paidOptIn === true) letteringCount += 1;
      if (shouldRequirePaidTextOptIn(text2Config) && viewState?.elements?.text2?.paidOptIn === true) letteringCount += 1;
    });
    return letteringCount;
  }

  function enforcePurchaseBagPaidOptInLimit(clickedInput, currentView, textNum) {
    if (!isPurchaseBag || !clickedInput?.checked) return true;
    const maxAllowed = getPurchaseBagMaxLetteringFees();
    if (maxAllowed <= 0) {
      clickedInput.checked = false;
      if (currentView?.elements?.[`text${textNum}`]) {
        currentView.elements[`text${textNum}`].paidOptIn = false;
      }
      showToast('This bag does not allow paid lettering.');
      return false;
    }
    const activeCount = getCurrentLetteringCountPerBag();
    if (activeCount > maxAllowed) {
      clickedInput.checked = false;
      if (currentView?.elements?.[`text${textNum}`]) {
        currentView.elements[`text${textNum}`].paidOptIn = false;
      }
      showToast(`Max ${maxAllowed} paid lettering option${maxAllowed === 1 ? '' : 's'} per bag.`);
      return false;
    }
    return true;
  }

  function parseVariantId(value) {
    if (value === null || value === undefined) return null;
    const str = String(value).trim();
    if (!str) return null;
    const gidMatch = str.match(/\/(\d+)$/);
    if (gidMatch) return Number(gidMatch[1]);
    const num = Number(str);
    return Number.isFinite(num) && num > 0 ? num : null;
  }

  function getPurchaseBagFeeVariantId(letteringCount) {
    const map = window.pcPurchaseBagFeeVariantMap || {};
    const raw = (map[String(letteringCount)] ?? map[letteringCount]);
    const parsed = parseVariantId(raw);
    return parsed;
  }

  function isViewColorSelectionInherited(view) {
    return !isPurchaseBag && !!String(view?.linkedToViewId || '').trim();
  }

  function isOptionalLayerHidden(view, layer) {
    if (!view || !layer || layer.optional !== true) return false;
    return !!(view.optionalLayersHidden && view.optionalLayersHidden[layer.id] === true);
  }

  /** Matches admin Customizer Builder “relationship map” grouping (same non-empty name + color links). */
  function normalizeLayerNameEquiv(name) {
    return String(name || '').trim().toLowerCase();
  }

  function splitViewLayerKeyStorefront(key) {
    var i = key.indexOf(':');
    if (i < 0) return [null, null];
    return [key.slice(0, i), key.slice(i + 1)];
  }

  function getLayerEquivGroupKeysStorefront(anchorViewId, anchorLayerId) {
    var nodes = [];
    var keyToIndex = {};
    state.views.forEach(function (view) {
      (view.layers || []).forEach(function (layer) {
        var key = view.id + ':' + layer.id;
        keyToIndex[key] = nodes.length;
        nodes.push({
          key: key,
          linkedLayerId: layer.linkedLayerId || null,
          normName: normalizeLayerNameEquiv(layer.name)
        });
      });
    });
    var n = nodes.length;
    if (n === 0) return [anchorViewId + ':' + anchorLayerId];
    var parent = [];
    for (var x = 0; x < n; x++) parent[x] = x;
    function find(a) {
      return parent[a] === a ? a : (parent[a] = find(parent[a]));
    }
    function union(a, b) {
      var ra = find(a);
      var rb = find(b);
      if (ra !== rb) parent[rb] = ra;
    }
    var nameBuckets = {};
    nodes.forEach(function (node, i) {
      if (!node.normName) return;
      if (!nameBuckets[node.normName]) nameBuckets[node.normName] = [];
      nameBuckets[node.normName].push(i);
    });
    Object.keys(nameBuckets).forEach(function (nm) {
      var arr = nameBuckets[nm];
      for (var k = 1; k < arr.length; k++) union(arr[0], arr[k]);
    });
    nodes.forEach(function (node, i) {
      var lid = node.linkedLayerId;
      if (!lid || typeof lid !== 'string') return;
      var j = keyToIndex[lid];
      if (j !== undefined) union(i, j);
    });
    var myKey = anchorViewId + ':' + anchorLayerId;
    var start = keyToIndex[myKey];
    if (start === undefined) return [myKey];
    var root = find(start);
    var out = [];
    for (var i = 0; i < n; i++) {
      if (find(i) === root) out.push(nodes[i].key);
    }
    return out;
  }

  function setOptionalHiddenForEquivGroup(anchorView, anchorLayer, hidden) {
    if (!anchorView || !anchorLayer || anchorLayer.optional !== true) return;
    var keys = getLayerEquivGroupKeysStorefront(anchorView.id, anchorLayer.id);
    keys.forEach(function (key) {
      var parts = splitViewLayerKeyStorefront(key);
      var vid = parts[0];
      var lid = parts[1];
      var v = state.views.find(function (x) { return x.id === vid; });
      if (!v) return;
      var layer = (v.layers || []).find(function (l) { return l.id === lid; });
      if (!layer || layer.optional !== true) return;
      if (!v.optionalLayersHidden) v.optionalLayersHidden = {};
      if (hidden) v.optionalLayersHidden[lid] = true;
      else delete v.optionalLayersHidden[lid];
    });
  }

  /** One row per equivalence group (same name / color links). Optional layers only. */
  function isOptionalGroupFullyShown(anchorView, anchorLayer) {
    const keys = getLayerEquivGroupKeysStorefront(anchorView.id, anchorLayer.id);
    return keys.every(function (key) {
      const parts = splitViewLayerKeyStorefront(key);
      const v = state.views.find(function (x) { return x.id === parts[0]; });
      const l = v && (v.layers || []).find(function (x) { return x.id === parts[1]; });
      if (!l || l.optional !== true) return true;
      return !isOptionalLayerHidden(v, l);
    });
  }

  function appendOptionalLayerControlsDeduped(parentEl) {
    if (!parentEl) return;
    const seenGroupIds = new Set();
    const representatives = [];
    state.views.forEach(function (view) {
      (view.layers || []).forEach(function (layer) {
        if (!layer || layer.optional !== true) return;
        var gk = getLayerEquivGroupKeysStorefront(view.id, layer.id);
        var gid = gk.slice().sort().join('|');
        if (seenGroupIds.has(gid)) return;
        seenGroupIds.add(gid);
        representatives.push({ view: view, layer: layer });
      });
    });
    if (representatives.length === 0) return;
    const box = document.createElement('div');
    box.className = 'pc-section pc-optional-layers-section';
    const inner = document.createElement('div');
    inner.className = 'pc-optional-layers-inner';
    const title = document.createElement('div');
    title.className = 'pc-optional-layers-title';
    title.textContent = 'Optional parts';
    inner.appendChild(title);
    const hint = document.createElement('p');
    hint.className = 'pc-optional-layers-hint';
    hint.textContent = 'Uncheck to remove an optional part everywhere it is linked.';
    inner.appendChild(hint);
    const list = document.createElement('div');
    list.className = 'pc-optional-layers-list';
    representatives.forEach(function (rep) {
      var view = rep.view;
      var layer = rep.layer;
      const row = document.createElement('label');
      row.className = 'pc-optional-layer-row';
      const textCol = document.createElement('span');
      textCol.className = 'pc-optional-layer-text';
      const nameEl = document.createElement('span');
      nameEl.className = 'pc-optional-layer-name';
      nameEl.textContent = layer.name || 'Optional layer';
      textCol.appendChild(nameEl);
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = 'pc-optional-layer-checkbox';
      cb.checked = isOptionalGroupFullyShown(view, layer);
      cb.addEventListener('change', function () {
        setOptionalHiddenForEquivGroup(view, layer, !cb.checked);
        generateLayers();
        generateTexts();
        generateLogos();
        generateControls();
        updateNextButtonState();
        generateViewToggle();
      });
      row.appendChild(textCol);
      row.appendChild(cb);
      list.appendChild(row);
    });
    inner.appendChild(list);
    box.appendChild(inner);
    parentEl.appendChild(box);
  }

  // Standard customizer: Step 1 should show ALL unique layer color choices across base views
  // (views that are not linkedToViewId), and should skip any layer whose color is derived/locked:
  // - lockColor / linkedTextKey (layer color linked to text color)
  // - linkedLayerId (layer-to-layer link; color derives from another layer)
  function buildStandardColorSteps() {
    if (isPurchaseBag) return [];
    const steps = [];
    
    // Collect "source" layers that other layers link to (layer-to-layer linking).
    const linkedTargets = new Set(); // `${viewId}:${layerId}`
    state.views.forEach((v) => {
      (v?.layers || []).forEach((l) => {
        if (!l?.linkedLayerId || typeof l.linkedLayerId !== 'string') return;
        if (!l.linkedLayerId.includes(':')) return;
        linkedTargets.add(l.linkedLayerId);
      });
    });

    // Prefer "root" views for Step 1. Normally, linked views inherit colors and shouldn't be scanned.
    // But some configs can accidentally create cycles (e.g. Front <-> Back), which would exclude everything.
    // In that case, we pick ONE representative (lowest index) from each cycle so colors are still pickable once.
    const viewsArr = Array.isArray(state?.views) ? state.views : [];
    const indexById = new Map(viewsArr.map((v, idx) => [v?.id, idx]));
    const viewById = new Map(viewsArr.map((v) => [v?.id, v]));

    function getCycleRepresentativeId(startId) {
      const visited = new Set();
      const order = [];
      let cur = startId;
      while (cur && !visited.has(cur)) {
        visited.add(cur);
        order.push(cur);
        const v = viewById.get(cur);
        const next = v?.linkedToViewId ? String(v.linkedToViewId) : null;
        cur = next;
      }
      // If we ended because of a repeat, we have a cycle; pick lowest index among nodes in this chain.
      if (cur && visited.has(cur)) {
        let bestId = null;
        let bestIdx = Infinity;
        order.forEach((id) => {
          const idx = indexById.has(id) ? indexById.get(id) : Infinity;
          if (idx < bestIdx) {
            bestIdx = idx;
            bestId = id;
          }
        });
        return bestId;
      }
      return null;
    }

    const rootViewIds = new Set();
    viewsArr.forEach((v) => {
      if (!v?.id) return;
      const linked = !!String(v.linkedToViewId || '').trim();
      if (!linked) {
        rootViewIds.add(v.id);
        return;
      }
      const rep = getCycleRepresentativeId(v.id);
      if (rep) rootViewIds.add(rep);
    });

    const baseViews = viewsArr.filter((v) => v && rootViewIds.has(v.id));
    const viewsToScan = baseViews.length > 0 ? baseViews : viewsArr.filter(Boolean);

    viewsToScan.forEach((view) => {
      if (!Array.isArray(view.layers) || view.layers.length === 0) return;
      const sortedLayers = [...view.layers].sort((a, b) => (a?.zIndex ?? 0) - (b?.zIndex ?? 0));
      sortedLayers.forEach((layer) => {
        if (!layer) return;
        // Keep hidden optional layers so their colour section + toggle checkbox stays visible.

        const locked = isLayerColorLocked(layer);
        const isLinkedLayer = !!layer.linkedLayerId; // derived from another layer
        const isTargetLayer = linkedTargets.has(`${view.id}:${layer.id}`); // other layers point to this

        if (locked) return;
        // Logo color selectors should not be part of Step 1
        if (isLogoLayerByName(layer)) return;
        // If a layer is linked to another layer, it normally should not be directly editable.
        // However, if other layers link TO this layer, it's a "source" layer and must be editable in Step 1.
        if (isLinkedLayer && !isTargetLayer) return;

        steps.push({ type: 'layer', viewId: view.id, layerId: layer.id, data: layer });
      });
    });

    // If we still have no steps but there are linkedTargets, add the target layers directly (safety net).
    if (steps.length === 0 && linkedTargets.size > 0) {
      linkedTargets.forEach((key) => {
        const [targetViewId, targetLayerId] = String(key).split(':');
        const targetView = state.views.find((v) => v?.id === targetViewId);
        const targetLayer = targetView?.layers?.find((l) => l?.id === targetLayerId);
        if (!targetView || !targetLayer) return;
        if (isLayerColorLocked(targetLayer)) return;
        if (isOptionalLayerHidden(targetView, targetLayer)) return;
        steps.push({ type: 'layer', viewId: targetView.id, layerId: targetLayer.id, data: targetLayer });
      });
    }
    return steps;
  }

  function buildCustomizationStepsForView(view) {
    const steps = [];
    if (!view) return steps;

    // Standard customizer: Step 2 should not show colors again (avoid repeats).
    if (!isPurchaseBag && isStandardCustomizeStage()) {
      // Show only LOGO layer color selectors here (and only if no text is linked to that layer).
      if (view.layers && view.layers.length > 0) {
        const sortedLayers = [...view.layers].sort((a, b) => a.zIndex - b.zIndex);
        sortedLayers.forEach((layer) => {
          if (!layer) return;
          if (isOptionalLayerHidden(view, layer)) return;
          if (!isLogoLayerByName(layer)) return;
          if (isLayerColorLocked(layer)) return;
          if (layer.linkedLayerId) return;
          if (isAnyTextLinkedToLayer(view, layer.id)) return; // text drives this color
          steps.push({ type: 'layer', data: layer });
        });
      }
    }
    // Otherwise, do not ask for colors again on linked views; colors are inherited from source view.
    else if (!isViewColorSelectionInherited(view) && view.layers && view.layers.length > 0) {
      const sortedLayers = [...view.layers].sort((a, b) => a.zIndex - b.zIndex);
      sortedLayers.forEach((layer) => {
        if (isLayerColorLocked(layer)) return;
        if (isOptionalLayerHidden(view, layer)) return;
        steps.push({ type: 'layer', data: layer });
      });
    }

    if (view.logo.enabled !== false) steps.push({ type: 'logo', data: view.logo });
    [view.text1, view.text2].forEach((textConfig, idx) => {
      if (textConfig.enabled !== false) steps.push({ type: 'text', data: textConfig, num: idx + 1 });
    });
    if (view.logoOrText && view.logoOrText.enabled) {
      steps.push({ type: 'logoOrText', data: view.logoOrText });
    }
    return steps;
  }

  function isStandardColorsStage() {
    return !isPurchaseBag && state.standardJourneyStage === 'colors';
  }

  function isStandardCustomizeStage() {
    return !isPurchaseBag && state.standardJourneyStage === 'customize';
  }

  function getPurchaseBagLetteringFeeTotal() {
    const strips = Math.max(0, Number(getCurrentLetteringCountPerBag()) || 0);
    return {
      strips,
      total: strips * 12
    };
  }

  const purchaseBagInitialBodyHex = isPurchaseBag
    ? getPurchaseBagBodyHexFromVariant(window.pcPurchaseBagInitialVariant)
    : null;

  function getCurrentPurchaseBagVariantContext() {
    const formId = window.pcPurchaseBagProductFormId;
    const form = formId ? document.getElementById(formId) : null;
    const variantInput = form?.querySelector('input[name="id"]') || form?.querySelector('.product-variant-id');
    const selectedVariantId = variantInput?.value ? String(variantInput.value) : null;
    const variants = Array.isArray(window.pcPurchaseBagVariants) ? window.pcPurchaseBagVariants : [];
    const selectedVariant = selectedVariantId ? variants.find((v) => String(v?.id) === selectedVariantId) : null;
    return { selectedVariantId, selectedVariant, hasForm: !!form, hasVariantInput: !!variantInput };
  }

  function getActivePurchaseBagBodyHex() {
    const ctx = getCurrentPurchaseBagVariantContext();
    if (ctx?.selectedVariant) {
      return getPurchaseBagBodyHexFromVariant(ctx.selectedVariant);
    }
    return purchaseBagInitialBodyHex || PURCHASE_BAG_BLACK_HEX;
  }

  // ELEMENTS
  const modal = document.getElementById('pc-modal');
  const closeBtn = document.getElementById('pc-close-btn');

  const step1 = document.getElementById('pc-step-1');
  const step2 = document.getElementById('pc-step-2');
  const toStep2Btn = document.getElementById('pc-to-step-2');
  const backToStep1Btn = document.getElementById('pc-back-to-step-1');
  const backStepMobileBtn = document.getElementById('pc-back-step-mobile');
  const saveBtn = document.getElementById('pc-save-btn');
  const saveBtnMobile = document.getElementById('pc-save-btn-mobile');
  const resetDesignBtn = document.getElementById('pc-reset-design-btn');
  const resetDesignBtnMobile = document.getElementById('pc-reset-design-btn-mobile');
  const downloadViewsBtn = document.getElementById('pc-download-views-btn');
  const quoteForm = document.getElementById('pc-quote-form');
  const submitBtn = document.getElementById('pc-submit-btn');
  
  const viewToggle = document.getElementById('pc-view-toggle');
  const viewPrevBtn = document.getElementById('pc-view-prev-btn');
  const viewNextBtn = document.getElementById('pc-view-next-btn');
  const stickyHeader = document.getElementById('pc-sticky-header');
  const step1ViewArea = document.querySelector('#pc-step-1 .pc-view-area');
  const canvasContainer = document.getElementById('pc-canvas');
  const layersContainer = document.getElementById('pc-layers-container');
  const logosContainer = document.getElementById('pc-logos-container');
  const textsContainer = document.getElementById('pc-texts-container');
  const controlsContainer = document.getElementById('pc-controls-container');
  const journeyProgressEl = document.getElementById('pc-journey-progress');
  const svgFilters = document.getElementById('pc-svg-filters').querySelector('defs');
  const hiddenInput = document.getElementById('pc-data-hidden');
  const controlsAreaEl = document.querySelector('#pc-step-1 .pc-controls-area');

  // In purchase-bag mode we force all layer colors:
  // - First layer (bag body) = selected variant color
  // - All other layers = brand black
  // And we lock every layer to hide layer color UI.
  if (isPurchaseBag && Array.isArray(views) && views.length > 0) {
    const bodyHex = getActivePurchaseBagBodyHex();

    views = views.map((view) => {
      const layers = Array.isArray(view.layers) ? view.layers : [];
      const updatedLayers = layers.map((layer, idx) => ({
        ...layer,
        lockColor: true,
        defaultColor: getPurchaseBagLockedLayerColor(layer, idx, bodyHex)
      }));

      return { ...view, layers: updatedLayers };
    });
  }

  // STATE
  const state = {
    currentViewIndex: 0,
    mobileLayerStep: 0, // For step-by-step mobile experience
    standardJourneyStage: isPurchaseBag ? 'customize' : 'colors',
    views: views.map((view, idx) => {
      const mappedView = {
      ...view,
      linkedToViewId: view.linkedToViewId || null,
      logoOrText: view.logoOrText || null,
      text1: view.text1 ? { ...view.text1, linkedLayerId: view.text1.linkedLayerId || null } : view.text1,
      text2: view.text2 ? { ...view.text2, linkedLayerId: view.text2.linkedLayerId || null } : view.text2,
      parts: view.layers.reduce((acc, layer) => {
        acc[layer.id] = getLayerInitialColor(layer);
        return acc;
      }, {}),
      optionalLayersHidden: {},
      elements: {
        logo: { active: false, src: null, originalSrc: null, size: view.logo.size },
          text1: { active: false, content: '', color: '#FFFFFF', size: (view.text1.sizeDefault != null ? view.text1.sizeDefault : view.text1.size) },
          text2: { active: false, content: '', color: '#FFFFFF', size: (view.text2.sizeDefault != null ? view.text2.sizeDefault : view.text2.size) },
        logoOrText: {
          mode: 'text',
          content: '',
          color: (view.logoOrText && view.logoOrText.defaultColor) ? view.logoOrText.defaultColor : '#363636',
          size: (view.logoOrText && (view.logoOrText.sizeTextDefault != null || view.logoOrText.sizeText != null))
            ? (view.logoOrText.sizeTextDefault != null ? view.logoOrText.sizeTextDefault : view.logoOrText.sizeText)
            : 2,
          logoSize: null,
          logo: { active: false, src: null, originalSrc: null }
        }
      }
      };
      enforceLockedTextContent(mappedView);
      return mappedView;
    }),
    colorHistory: [],
    canvasZoom: 1,
    canvasPanX: 0,
    canvasPanY: 0
  };

  // Purchase-bag + async config: rebuild state.views once config finishes loading.
  function rebuildStateViewsFromLoadedConfig() {
    // Ensure purchase-bag forcing applies to newly loaded views.
    if (isPurchaseBag && Array.isArray(views) && views.length > 0) {
      const bodyHex = getActivePurchaseBagBodyHex();
      views = views.map((view) => {
        const layers = Array.isArray(view.layers) ? view.layers : [];
        const updatedLayers = layers.map((layer, idx) => ({
          ...layer,
          lockColor: true,
          defaultColor: getPurchaseBagLockedLayerColor(layer, idx, bodyHex)
        }));
        return { ...view, layers: updatedLayers };
      });
    }

    state.currentViewIndex = 0;
    state.mobileLayerStep = 0;
    state.mobileCustomizationStep = 0;
    state.standardJourneyStage = isPurchaseBag ? 'customize' : 'colors';
    state.views = views.map((view, idx) => {
      const mappedView = {
      ...view,
      linkedToViewId: view.linkedToViewId || null,
      logoOrText: view.logoOrText || null,
      text1: view.text1 ? { ...view.text1, linkedLayerId: view.text1.linkedLayerId || null } : view.text1,
      text2: view.text2 ? { ...view.text2, linkedLayerId: view.text2.linkedLayerId || null } : view.text2,
      parts: view.layers.reduce((acc, layer) => {
        acc[layer.id] = getLayerInitialColor(layer);
        return acc;
      }, {}),
      optionalLayersHidden: {},
      elements: {
        logo: { active: false, src: null, originalSrc: null, size: view.logo.size },
          text1: { active: false, content: '', color: '#FFFFFF', size: (view.text1.sizeDefault != null ? view.text1.sizeDefault : view.text1.size) },
          text2: { active: false, content: '', color: '#FFFFFF', size: (view.text2.sizeDefault != null ? view.text2.sizeDefault : view.text2.size) },
        logoOrText: {
          mode: 'text',
          content: '',
          color: (view.logoOrText && view.logoOrText.defaultColor) ? view.logoOrText.defaultColor : '#363636',
          size: (view.logoOrText && (view.logoOrText.sizeTextDefault != null || view.logoOrText.sizeText != null))
            ? (view.logoOrText.sizeTextDefault != null ? view.logoOrText.sizeTextDefault : view.logoOrText.sizeText)
            : 2,
          logoSize: null,
          logo: { active: false, src: null, originalSrc: null }
        }
      }
      };
      enforceLockedTextContent(mappedView);
      return mappedView;
    });
  }

  // Sync linked views' layer colors from their source view (by layer index)
  // Also sync layer-to-layer links with cascading to view-level linked views
  function syncLinkedViewParts() {
    if (isPurchaseBag) return;
    // First, sync view-level links (by layer index)
    state.views.forEach((view, viewIndex) => {
      if (!view.linkedToViewId) return;
      const sourceView = state.views.find(v => v.id === view.linkedToViewId);
      if (!sourceView) return;
      view.layers.forEach((layer, layerIndex) => {
        const sourceLayer = sourceView.layers[layerIndex];
        if (sourceLayer && sourceView.parts[sourceLayer.id] !== undefined) {
          view.parts[layer.id] = sourceView.parts[sourceLayer.id];
        }
      });
    });
    
    // Then, sync layer-to-layer links - iterate multiple times to handle cascading
    // We need multiple passes because layer-to-layer links can cascade to view-level links
    let changed = true;
    let iterations = 0;
    const maxIterations = 10; // Prevent infinite loops
    
    while (changed && iterations < maxIterations) {
      changed = false;
      iterations++;
      
      state.views.forEach((view) => {
        view.layers.forEach((layer) => {
          if (layer.linkedLayerId && layer.linkedLayerId.includes(':')) {
            const [targetViewId, targetLayerId] = layer.linkedLayerId.split(':');
            const targetView = state.views.find(v => v.id === targetViewId);
            const targetLayer = targetView?.layers?.find(l => l.id === targetLayerId);
            
            if (targetView && targetLayer && targetView.parts[targetLayerId] !== undefined) {
              const targetColor = targetView.parts[targetLayerId];
              if (view.parts[layer.id] !== targetColor) {
                view.parts[layer.id] = targetColor;
                changed = true;
              }
              
              // CASCADE: If target view has view-level linked views, sync them too
              const targetLayerIndex = targetView.layers.findIndex(l => l.id === targetLayerId);
              if (targetLayerIndex >= 0) {
                state.views.forEach((linkedView) => {
                  if (linkedView.linkedToViewId === targetView.id && linkedView.layers[targetLayerIndex]) {
                    const linkedLayerId = linkedView.layers[targetLayerIndex].id;
                    if (linkedView.parts[linkedLayerId] !== targetColor) {
                      linkedView.parts[linkedLayerId] = targetColor;
                      changed = true;
                    }
                  }
                });
              }
            }
          }
        });
      });
    }
    
    if (iterations >= maxIterations) {
      // Avoid infinite loops if linked view mapping is inconsistent.
    }
  }
  syncLinkedViewParts();

  // Initialize
  if (views.length === 0) {
    if (!isPurchaseBag) {
      if (inlineBtn) inlineBtn.style.display = 'none';
      return;
    }
  }

  // =========================================================
  // VIEW CUSTOMIZATION VALIDATION
  // =========================================================
  function isViewCustomized(viewIndex) {
    const view = state.views[viewIndex];
    if (!view) return false;
    
    // A view is considered customized if it has layers (even with default colors)
    // Logo and text are optional bonuses - they don't need to be filled for the view to be valid
    const hasLayers = view.layers && view.layers.length > 0;
    
    // Check if logo has been uploaded (optional - only counts if actually filled)
    const hasLogo = view.logo && view.logo.enabled !== false && 
                    view.elements && view.elements.logo && 
                    view.elements.logo.active && 
                    view.elements.logo.src;
    
    // Check if text has been entered (optional - only counts if actually filled)
    const hasText1 = view.text1 && view.text1.enabled !== false && 
                     view.elements && view.elements.text1 && 
                     view.elements.text1.active && 
                     view.elements.text1.content && 
                     view.elements.text1.content.trim() !== '';
    
    const hasText2 = view.text2 && view.text2.enabled !== false && 
                     view.elements && view.elements.text2 && 
                     view.elements.text2.active && 
                     view.elements.text2.content && 
                     view.elements.text2.content.trim() !== '';
    
    const hasLogoOrText = view.logoOrText && view.logoOrText.enabled && view.elements && view.elements.logoOrText &&
      ((view.elements.logoOrText.mode === 'logo' && view.elements.logoOrText.logo && view.elements.logoOrText.logo.active && view.elements.logoOrText.logo.src) ||
       (view.elements.logoOrText.mode === 'text' && view.elements.logoOrText.content && String(view.elements.logoOrText.content).trim() !== ''));
    
    // View is customized if it has layers OR if logo/text are actually filled (optional)
    return hasLayers || hasLogo || hasText1 || hasText2 || hasLogoOrText;
  }
  
  // Check what's missing in the current view
  // Logo and text are optional - only layers are required
  function getCurrentViewMissingItems() {
    const view = state.views[state.currentViewIndex];
    if (!view) return [];
    
    const missing = [];
    
    // Check if view has layers at all
    const hasLayers = view.layers && view.layers.length > 0;
    if (!hasLayers) {
      missing.push('layers');
    }
    
    // Logo and text are optional - don't add them to missing items
    // They're bonuses that enhance the customization but aren't required
    
    return missing;
  }
  
  function areAllViewsCustomized() {
    return state.views.every((view, index) => isViewCustomized(index));
  }
  
  function updateNextButtonState() {
    const toStep2Btn = document.getElementById('pc-to-step-2');
    const backBtn = document.getElementById('pc-back-step-mobile');
    const warningMsg = document.getElementById('pc-completion-warning');
    
    if (!toStep2Btn) return;

    renderJourneyProgress();
    
    // Always enable the Next button - click handler will manage navigation
    toStep2Btn.disabled = false;
    
    const isMobile = false; /* mobile step-walk disabled: all controls shown in the scrolling panel */
    const allComplete = areAllViewsCustomized();

    if (isStandardColorsStage()) {
      const colorSteps = buildStandardColorSteps();
      const isMobileColorWalk = isMobile && colorSteps.length > 0;
      const onLastColorStep = !isMobileColorWalk || state.mobileCustomizationStep >= colorSteps.length - 1;
      toStep2Btn.textContent = onLastColorStep ? 'Next: Design' : 'Next color';
      if (backBtn) {
        backBtn.textContent = 'Back';
        backBtn.style.display = 'none';
      }
      return;
    }
    
    // Update button text and Back button visibility on mobile based on current step
    if (isMobile && state.mobileCustomizationStep !== undefined) {
      const currentView = state.views[state.currentViewIndex];
      const steps = buildCustomizationStepsForView(currentView);
      
      // Show/hide Back button based on step position
      const infoIcon = document.getElementById('pc-nav-info-icon');
      if (backBtn) {
        if (state.mobileCustomizationStep > 0 || state.currentViewIndex > 0) {
          backBtn.style.display = 'block';
          backBtn.disabled = false;
          // Hide info icon when Back button is visible for symmetric layout
          if (infoIcon) infoIcon.style.display = 'none';
        } else {
          backBtn.style.display = 'none';
          // Show info icon when Back button is hidden
          if (infoIcon) infoIcon.style.display = 'block';
        }
      } else if (infoIcon) {
        infoIcon.style.display = 'block';
      }
      
      if (state.mobileCustomizationStep < steps.length - 1) {
        toStep2Btn.textContent = 'Next';
      } else {
        toStep2Btn.textContent = 'Next: Details';
      }
    } else {
      // Desktop
      if (backBtn) {
        if (!isPurchaseBag && isStandardCustomizeStage()) {
          backBtn.textContent = 'Back to Colors';
          backBtn.style.display = 'block';
          backBtn.disabled = false;
        } else {
          backBtn.style.display = 'none';
        }
      }
      if (isPurchaseBag) {
        toStep2Btn.textContent = 'Add to cart';
      } else {
        toStep2Btn.textContent = isStandardCustomizeStage() ? 'Next: Details' : (allComplete ? 'Next: Details' : 'Next');
      }
    }
    
    // Remove pulse classes from all buttons first
    if (viewToggle) {
      const allBtns = viewToggle.querySelectorAll('.pc-view-btn');
      allBtns.forEach(btn => btn.classList.remove('pulse-warning'));
    }
    
    if (warningMsg) {
      if (allComplete) {
        // Hide warning if all views are complete
        warningMsg.style.display = 'none';
      } else {
        // Show warning about incomplete views (but don't block the button)
        const incompleteViews = state.views
          .map((view, idx) => ({ index: idx, name: view.name || `View ${idx + 1}` }))
          .filter((v, idx) => !isViewCustomized(idx));
        
        const viewList = incompleteViews.map(v => v.name).join(', ');
        warningMsg.textContent = `Please customize all views before proceeding. Missing: ${viewList}`;
        warningMsg.style.display = 'block';
        
        // Add pulse animation to incomplete view buttons
        setTimeout(() => {
          incompleteViews.forEach(v => {
            const btn = viewToggle.querySelector(`.pc-view-btn[data-view-index="${v.index}"]`);
            if (btn) btn.classList.add('pulse-warning');
          });
        }, 100);
      }
    }
  }

  function renderJourneyProgress() {
    if (!journeyProgressEl) return;

    const inFormStage = !step2?.classList?.contains('hidden-step');
    const items = isPurchaseBag
      ? [
          { key: 'customize', label: 'Design' },
          { key: 'cart', label: 'Add to cart' }
        ]
      : [
          { key: 'colors', label: 'Colors' },
          { key: 'customize', label: 'Design' },
          { key: 'form', label: 'Details' }
        ];

    let activeKey = isPurchaseBag ? 'customize' : 'colors';
    if (isPurchaseBag) {
      activeKey = 'customize';
    } else if (inFormStage) {
      activeKey = 'form';
    } else if (state.standardJourneyStage === 'customize') {
      activeKey = 'customize';
    } else {
      activeKey = 'colors';
    }

    const activeIndex = items.findIndex((i) => i.key === activeKey);
    journeyProgressEl.innerHTML = items
      .map((item, index) => {
        const statusClass = index < activeIndex ? 'completed' : (index === activeIndex ? 'active' : '');
        const isClickable = !isPurchaseBag;
        return `
          <button type="button" class="pc-journey-step ${statusClass}" data-journey-step="${item.key}" ${isClickable ? '' : 'disabled'}>
            <span class="pc-journey-step-num">${index + 1}</span>
            <span>${item.label}</span>
          </button>
        `;
      })
      .join('');
  }

  function goToStandardJourneyStep(targetKey) {
    if (isPurchaseBag) return;
    if (!targetKey) return;

    if (targetKey === 'colors') {
      if (step2 && !step2.classList.contains('hidden-step')) {
        step2.classList.add('hidden-step');
        step2.style.display = 'none';
        step1.style.display = 'flex';
        step1.classList.remove('hidden-step');
      }
      state.standardJourneyStage = 'colors';
      state.currentViewIndex = 0;
      state.mobileCustomizationStep = 0;
      switchView(0);
      if (controlsAreaEl) controlsAreaEl.scrollTop = 0;
      updateNextButtonState();
      return;
    }

    if (targetKey === 'customize') {
      if (step2 && !step2.classList.contains('hidden-step')) {
        step2.classList.add('hidden-step');
        step2.style.display = 'none';
        step1.style.display = 'flex';
        step1.classList.remove('hidden-step');
      }
      state.standardJourneyStage = 'customize';
      state.currentViewIndex = 0;
      state.mobileCustomizationStep = 0;
      switchView(0);
      if (controlsAreaEl) controlsAreaEl.scrollTop = 0;
      updateNextButtonState();
      return;
    }

    if (targetKey === 'form') {
      state.standardJourneyStage = 'customize';
      if (step1 && step2) {
        step1.classList.add('hidden-step');
        step1.style.display = 'none';
        step2.style.display = 'block';
        step2.classList.remove('hidden-step');
        step2.scrollTop = 0;
      }
      updateNextButtonState();
    }
  }

  function updateViewNavButtons() {
    const total = Array.isArray(state.views) ? state.views.length : 0;
    const hidden = total <= 1;
    if (viewPrevBtn) {
      viewPrevBtn.style.display = hidden ? 'none' : 'inline-flex';
      viewPrevBtn.disabled = hidden || state.currentViewIndex <= 0;
    }
    if (viewNextBtn) {
      viewNextBtn.style.display = hidden ? 'none' : 'inline-flex';
      viewNextBtn.disabled = hidden || state.currentViewIndex >= total - 1;
    }
  }

  function syncDesktopHeaderOffsets() {
    // Layout v3: header is in normal document flow; clear legacy inline offsets, then stop.
    var _ca = document.querySelector('#pc-step-1 .pc-controls-area');
    if (_ca) _ca.style.paddingTop = '';
    if (typeof step1ViewArea !== 'undefined' && step1ViewArea) step1ViewArea.style.paddingTop = '';
    return;
    if (!stickyHeader) return;
    const controlsArea = document.querySelector('#pc-step-1 .pc-controls-area');
    const isDesktop = window.innerWidth >= 1024;
    if (!controlsArea || !step1ViewArea) return;

    if (!isDesktop) {
      controlsArea.style.paddingTop = '';
      step1ViewArea.style.paddingTop = '';
      return;
    }

    const headerHeight = Math.max(0, stickyHeader.getBoundingClientRect().height || stickyHeader.offsetHeight || 0);
    const topOffset = Math.round(headerHeight + 14);
    controlsArea.style.paddingTop = `${topOffset}px`;
    step1ViewArea.style.paddingTop = `${Math.round(headerHeight + 8)}px`;
  }

  // =========================================================
  // INITIALIZATION
  // =========================================================
  function positionTooltips() {
    const infoIcons = document.querySelectorAll('.pc-info-icon[data-tooltip]');
    infoIcons.forEach(icon => {
      // Use a single event listener per icon
      if (icon.dataset.tooltipPositioned) return;
      icon.dataset.tooltipPositioned = 'true';
      
      icon.addEventListener('mouseenter', function() {
        const rect = this.getBoundingClientRect();
        const tooltipWidth = Math.min(250, window.innerWidth - 40); // Max width from CSS
        const viewportWidth = window.innerWidth;
        const spaceOnRight = viewportWidth - rect.right;
        const spaceOnLeft = rect.left;
        
        // If there's not enough space on the right but enough on the left, position tooltip to the right of icon
        if (spaceOnRight < tooltipWidth && spaceOnLeft > tooltipWidth) {
          this.classList.add('tooltip-right');
        } else {
          this.classList.remove('tooltip-right');
        }
      }, { once: false });
    });
  }

  function init() {
    generateViewToggle();
    generateLayers(); // This will also call initFilters() at the end
    generateLogos();
    generateTexts();
    generateControls(); // This generates the color swatches
    loadSavedDesign();
    if (isPurchaseBag) {
      const ctx = getCurrentPurchaseBagVariantContext();
      const activeBodyHex = getActivePurchaseBagBodyHex();
      applyPurchaseBagLockedLayerColors(activeBodyHex, { updateCurrentView: true });
    }
    updateNextButtonState();
    positionTooltips();
    setTimeout(() => initMobileFriendlyInputs(), 200);
  }

  function generateViewToggle() {
    if (!viewToggle) return;
    viewToggle.innerHTML = '';
    const viewToolbar = viewToggle.closest('.pc-view-toolbar');
    if (viewToolbar) viewToolbar.style.display = 'flex';
    views.forEach((view, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pc-view-btn' + (idx === state.currentViewIndex ? ' active' : '');
      btn.setAttribute('data-view-index', idx);
      const isCustomized = isViewCustomized(idx);
      const viewName = view.name || `View ${idx + 1}`;
      btn.textContent = isCustomized ? `✓ ${viewName}` : viewName;
      btn.title = isCustomized ? `${viewName} - Customized` : `${viewName} - Not customized yet`;
      btn.addEventListener('click', () => switchView(idx));
      viewToggle.appendChild(btn);
    });
    updateViewNavButtons();
  }

  function generateLayers() {
    if (!layersContainer) return;
    layersContainer.innerHTML = '';
    const currentView = state.views[state.currentViewIndex];
    if (!currentView || !currentView.layers) return;
    // Apply aspect lock before rendering layers so measurements match builder
    ensureAspectCanvasForCurrentView();
    
    
    
    const sortedLayers = [...currentView.layers].sort((a, b) => a.zIndex - b.zIndex);
    
    sortedLayers.forEach(layer => {
      if (isOptionalLayerHidden(currentView, layer)) return;
      // Ensure parts object has this layer initialized
      if (!currentView.parts.hasOwnProperty(layer.id)) {
        currentView.parts[layer.id] = getLayerInitialColor(layer);
      }
      
      const img = document.createElement('img');
      img.id = `layer-${currentView.id}-${layer.id}`;
      const shouldFlipLayer = currentView.flipLayers === true && layer.disableViewFlip !== true;
      img.className = 'pc-layer' + (shouldFlipLayer ? ' pc-flipped' : '');
      img.src = layer.image || '';
      img.style.zIndex = layer.zIndex;
      img.crossOrigin = 'anonymous'; // Important for SVG filters
      
      
      // Apply filter - will be set by initFilters, but ensure it's here too
      const filterId = `f-${currentView.id}-${layer.id}`;
      img.style.filter = `url(#${filterId})`;
      
      layersContainer.appendChild(img);
    });
    
    // Ensure filters are initialized after layers are created
    initFilters();
  }

  function generateLogos() {
    if (!logosContainer) return;
    logosContainer.innerHTML = '';
    const currentView = state.views[state.currentViewIndex];
    const logoState = currentView.elements.logo;
    
    // Check if logo is enabled in backend config AND has an active state with source
    if (currentView.logo.enabled !== false && logoState.active && logoState.src) {
      // Get canvas container dimensions for proportional scaling
      const canvasContainer = document.getElementById('pc-canvas');
      if (!canvasContainer) return;
      
      // Use requestAnimationFrame to ensure canvas is fully laid out before measuring
      requestAnimationFrame(() => {
        // Use getBoundingClientRect() for actual rendered dimensions
        const canvasRect = canvasContainer.getBoundingClientRect();
        let canvasWidth = canvasRect.width;
        let canvasHeight = canvasRect.height;
        
        // Fallback to offsetWidth if getBoundingClientRect fails
        if (!canvasWidth || canvasWidth <= 0) {
          canvasWidth = canvasContainer.offsetWidth || 400;
        }
        if (!canvasHeight || canvasHeight <= 0) {
          canvasHeight = canvasContainer.offsetHeight || 400;
        }
        
        // Ensure we have valid dimensions
        if (!canvasWidth || canvasWidth <= 0 || !canvasHeight || canvasHeight <= 0) {
          console.warn('[Customizer] Invalid canvas dimensions, retrying...');
          // Retry after a short delay if dimensions are invalid
          setTimeout(() => generateLogos(), 100);
          return;
        }
        
        // Continue with logo generation using the measured dimensions
        generateLogosWithDimensions(canvasWidth, canvasHeight, currentView, logoState);
      });
      return;
    }
    
    // Handle logoOrText logo mode (outside the main logo check)
    const lot = currentView.logoOrText;
    const lotState = currentView.elements.logoOrText;
    if (lot && lot.enabled && lotState && lotState.mode === 'logo' && lotState.logo && lotState.logo.active && lotState.logo.src) {
      const canvasContainer = document.getElementById('pc-canvas');
      if (!canvasContainer) return;
      
      requestAnimationFrame(() => {
        const canvasRect = canvasContainer.getBoundingClientRect();
        let canvasWidth = canvasRect.width;
        if (!canvasWidth || canvasWidth <= 0) {
          canvasWidth = canvasContainer.offsetWidth || 400;
        }
        if (!canvasWidth || canvasWidth <= 0) {
          setTimeout(() => generateLogos(), 100);
          return;
        }
        const referenceCanvasWidth = 400;
        const logoSizePx = (lotState.logoSize != null ? lotState.logoSize : lot.sizeLogo) != null ? (lotState.logoSize != null ? lotState.logoSize : lot.sizeLogo) : 150;
        const isMobile = window.innerWidth < 768;
        const mobileScaleFactor = isMobile ? 0.75 : 1;
        const scaledLogoSize = (logoSizePx / referenceCanvasWidth) * canvasWidth * mobileScaleFactor;
        const logoDiv = document.createElement('div');
        logoDiv.className = 'pc-logo-element pc-logoortext-element';
        logoDiv.id = 'pc-logoortext-logo-element';
        logoDiv.style.position = 'absolute';
        logoDiv.style.left = (lot.positionX ?? 50) + '%';
        logoDiv.style.top = (lot.positionY ?? 55) + '%';
        logoDiv.style.transform = `translate(-50%, -50%) rotate(${lot.rotation ?? 0}deg) skew(${lot.skewX ?? 0}deg, ${lot.skewY ?? 0}deg)`;
        logoDiv.style.zIndex = '1003';
        logoDiv.style.pointerEvents = 'none';
        logoDiv.style.width = scaledLogoSize + 'px';
        logoDiv.style.height = scaledLogoSize + 'px';
        logoDiv.style.display = 'flex';
        logoDiv.style.alignItems = 'center';
        logoDiv.style.justifyContent = 'center';
        const img = document.createElement('img');
        img.src = lotState.logo.src;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        logoDiv.appendChild(img);
        logosContainer.appendChild(logoDiv);
      });
    }
  }
  
  function generateLogosWithDimensions(canvasWidth, canvasHeight, currentView, logoState) {
    if (!logosContainer) return;
      
      // Reference canvas width (desktop max-width)
      const referenceCanvasWidth = 400;
      
      // Extra diagnostics: canvas paddings/borders and possible builder ref dims
      
      
      // Get logo size from state or config (stored as pixels for 400px canvas)
      const logoSizePx = logoState.size || currentView.logo.size || 150;
      
      // Scale logo size proportionally to actual canvas width
      // Apply mobile scaling factor (reduce size on mobile for better fit)
      const isMobile = window.innerWidth < 768;
      const mobileScaleFactor = isMobile ? 0.75 : 1; // 25% smaller on mobile
      const scaledLogoSize = (logoSizePx / referenceCanvasWidth) * canvasWidth * mobileScaleFactor;
      
      const logoDiv = document.createElement('div');
      logoDiv.className = 'pc-logo-element';
      logoDiv.id = 'pc-logo-element';
      logoDiv.style.position = 'absolute';
      // Use defaults if values are undefined/null (positionX/Y default to 50%, rotation/skew default to 0)
      const logoPositionX = (currentView.logo.positionX != null) ? currentView.logo.positionX : 50;
      const logoPositionY = (currentView.logo.positionY != null) ? currentView.logo.positionY : 50;
      const logoRotation = (currentView.logo.rotation != null) ? currentView.logo.rotation : 0;
      const logoSkewX = (currentView.logo.skewX != null) ? currentView.logo.skewX : 0;
      const logoSkewY = (currentView.logo.skewY != null) ? currentView.logo.skewY : 0;
      logoDiv.style.left = logoPositionX + '%';
      logoDiv.style.top = logoPositionY + '%';
      logoDiv.style.transform = `translate(-50%, -50%) rotate(${logoRotation}deg) skew(${logoSkewX}deg, ${logoSkewY}deg)`;
      logoDiv.style.zIndex = '1000';
      logoDiv.style.pointerEvents = 'auto';
      logoDiv.classList.add('pc-draggable-element');
      // Anchor position (original placement) for movement cap
      if (currentView.elements?.logo && typeof currentView.elements.logo.anchorX !== 'number') {
        currentView.elements.logo.anchorX = logoPositionX;
        currentView.elements.logo.anchorY = logoPositionY;
      }
      
      logoDiv.style.width = scaledLogoSize + 'px';
      logoDiv.style.height = scaledLogoSize + 'px';
      logoDiv.style.display = 'flex';
      logoDiv.style.alignItems = 'center';
      logoDiv.style.justifyContent = 'center';
      
      const img = document.createElement('img');
      img.src = logoState.src;
      img.className = 'pc-logo-img';
      img.id = 'pc-logo-img';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'contain';
      logoDiv.appendChild(img);
      logosContainer.appendChild(logoDiv);

      // Allow subtle nudging: max 50px from anchor in any direction
      setupDragAndDrop(
        logoDiv,
        (newX, newY) => {
          currentView.logo.positionX = newX;
          currentView.logo.positionY = newY;
          logoDiv.style.left = newX + '%';
          logoDiv.style.top = newY + '%';
        },
        {
          maxDeltaPx: 50,
          getAnchor: () => ({ x: currentView.elements?.logo?.anchorX ?? logoPositionX, y: currentView.elements?.logo?.anchorY ?? logoPositionY })
        }
      );
  }

  function setupDragAndDrop(element, onUpdate, { maxDeltaPx = null, getAnchor = null } = {}) {
    let isDragging = false;
    let startX = 0, startY = 0;
    let startLeft = 0, startTop = 0;
    let anchorLeft = null, anchorTop = null;
    
    element.addEventListener('mousedown', (e) => {
      isDragging = true;
      const rect = canvasContainer.getBoundingClientRect();
      startX = e.clientX;
      startY = e.clientY;
      startLeft = parseFloat(element.style.left) || 0;
      startTop = parseFloat(element.style.top) || 0;
      if (typeof getAnchor === 'function') {
        const a = getAnchor();
        anchorLeft = a && typeof a.x === 'number' ? a.x : startLeft;
        anchorTop = a && typeof a.y === 'number' ? a.y : startTop;
      } else {
        anchorLeft = startLeft;
        anchorTop = startTop;
      }
      e.preventDefault();
    });
    
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const rect = canvasContainer.getBoundingClientRect();
      const rawDeltaXPx = (e.clientX - startX);
      const rawDeltaYPx = (e.clientY - startY);
      const clampedDeltaXPx = (typeof maxDeltaPx === 'number' && maxDeltaPx >= 0)
        ? Math.max(-maxDeltaPx, Math.min(maxDeltaPx, rawDeltaXPx))
        : rawDeltaXPx;
      const clampedDeltaYPx = (typeof maxDeltaPx === 'number' && maxDeltaPx >= 0)
        ? Math.max(-maxDeltaPx, Math.min(maxDeltaPx, rawDeltaYPx))
        : rawDeltaYPx;

      const deltaX = (clampedDeltaXPx / rect.width) * 100;
      const deltaY = (clampedDeltaYPx / rect.height) * 100;
      const candidateX = Math.max(0, Math.min(100, anchorLeft + deltaX));
      const candidateY = Math.max(0, Math.min(100, anchorTop + deltaY));
      const mask = getPrintableMaskForView(state.views[state.currentViewIndex]);
      if (!mask || isPointAllowedByMask(mask, candidateX, candidateY, rect)) {
        onUpdate(candidateX, candidateY);
      }
    });
    
    document.addEventListener('mouseup', () => {
      isDragging = false;
    });
    
    // Touch support
    element.addEventListener('touchstart', (e) => {
      isDragging = true;
      const rect = canvasContainer.getBoundingClientRect();
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startLeft = parseFloat(element.style.left) || 0;
      startTop = parseFloat(element.style.top) || 0;
      if (typeof getAnchor === 'function') {
        const a = getAnchor();
        anchorLeft = a && typeof a.x === 'number' ? a.x : startLeft;
        anchorTop = a && typeof a.y === 'number' ? a.y : startTop;
      } else {
        anchorLeft = startLeft;
        anchorTop = startTop;
      }
      e.preventDefault();
    });
    
    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const rect = canvasContainer.getBoundingClientRect();
      const touch = e.touches[0];
      const rawDeltaXPx = (touch.clientX - startX);
      const rawDeltaYPx = (touch.clientY - startY);
      const clampedDeltaXPx = (typeof maxDeltaPx === 'number' && maxDeltaPx >= 0)
        ? Math.max(-maxDeltaPx, Math.min(maxDeltaPx, rawDeltaXPx))
        : rawDeltaXPx;
      const clampedDeltaYPx = (typeof maxDeltaPx === 'number' && maxDeltaPx >= 0)
        ? Math.max(-maxDeltaPx, Math.min(maxDeltaPx, rawDeltaYPx))
        : rawDeltaYPx;

      const deltaX = (clampedDeltaXPx / rect.width) * 100;
      const deltaY = (clampedDeltaYPx / rect.height) * 100;
      const candidateX = Math.max(0, Math.min(100, anchorLeft + deltaX));
      const candidateY = Math.max(0, Math.min(100, anchorTop + deltaY));
      const mask = getPrintableMaskForView(state.views[state.currentViewIndex]);
      if (!mask || isPointAllowedByMask(mask, candidateX, candidateY, rect)) {
        onUpdate(candidateX, candidateY);
      }
      e.preventDefault();
    });
    
    document.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  // Printable-area mask (color detector): build once per view and cache.
  // We treat any non-transparent pixel in the composed view layers as "allowed".
  // Optional: if an image lacks alpha, treat very light pixels (luminance > 0.95) as background.
  const __pcViewIdToMask = new Map();
  function getPrintableMaskForView(view) {
    if (!view || !Array.isArray(view.layers) || view.layers.length === 0) return null;
    if (__pcViewIdToMask.has(view.id)) return __pcViewIdToMask.get(view.id);
    try {
      const canvas = document.createElement('canvas');
      const viewArea = canvasContainer?.getBoundingClientRect?.() ? canvasContainer.getBoundingClientRect() : { width: 400, height: 400 };
      const w = Math.max(1, Math.floor(viewArea.width));
      const h = Math.max(1, Math.floor(viewArea.height));
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) return null;
      // Draw each layer image in order
      view.layers.forEach((layer) => {
        const img = document.getElementById(`layer-${view.id}-${layer.id}`);
        if (!img) return;
        try {
          ctx.drawImage(img, 0, 0, w, h);
        } catch (_) {
          // ignore CORS or draw errors
        }
      });
      const imageData = ctx.getImageData(0, 0, w, h);
      const data = imageData.data;
      __pcViewIdToMask.set(view.id, { w, h, data });
      return { w, h, data };
    } catch (_) {
      return null;
    }
  }

  // Aspect lock: try to match builder reference aspect while keeping similar size
  function getBuilderAspectForView(view) {
    if (!view) return null;
    const bw = Number(view?.builderCanvasWidth);
    const bh = Number(view?.builderCanvasHeight);
    if (bw > 0 && bh > 0) return bw / bh;
    // Fallback: first layer image natural aspect
    const firstLayer = Array.isArray(view.layers) && view.layers.length > 0 ? view.layers[0] : null;
    if (firstLayer) {
      const img = document.getElementById(`layer-${view.id}-${firstLayer.id}`);
      if (img && img.naturalWidth && img.naturalHeight) {
        return img.naturalWidth / img.naturalHeight;
      }
    }
    return null;
  }

  function ensureAspectCanvasForCurrentView() {
    const view = state.views[state.currentViewIndex];
    const aspect = getBuilderAspectForView(view);
    const container = document.getElementById('pc-canvas');
    if (!container || !aspect) return;
    const parent = container.parentElement;
    const parentRect = parent?.getBoundingClientRect?.() || { width: container.offsetWidth || 520, height: container.offsetHeight || 520 };
    const current = container.getBoundingClientRect?.() || { width: parentRect.width, height: parentRect.height };
    // Keep width near current, compute height from aspect; adjust if it overflows parent height
    let targetW = current.width || parentRect.width || 520;
    let targetH = Math.round(targetW / aspect);
    if (targetH > parentRect.height) {
      targetH = Math.min(parentRect.height, targetH);
      targetW = Math.round(targetH * aspect);
    }
    container.style.width = `${targetW}px`;
    container.style.height = `${targetH}px`;
    container.style.maxWidth = `${targetW}px`;
    container.style.maxHeight = `${targetH}px`;
    container.style.minWidth = `${targetW}px`;
    container.style.minHeight = `${targetH}px`;
    const r = container.getBoundingClientRect();
    if (view && r.width > 0 && r.height > 0) {
      view.previewCanvasWidth = r.width;
      view.previewCanvasHeight = r.height;
    }
  }

  /**
   * Snapshot logical #pc-canvas size per view for the quote API (matches server JPEG aspect).
   * Uses the same sizing rules as ensureAspectCanvasForCurrentView; run before submit/download.
   */
  function assignPreviewCanvasMetricsToAllViews() {
    const container = document.getElementById('pc-canvas');
    if (!container || !Array.isArray(state.views)) return;
    const parent = container.parentElement;
    const parentRect = parent?.getBoundingClientRect?.() || { width: 520, height: 520 };
    const current = container.getBoundingClientRect?.();
    const baseW = (current && current.width > 0) ? current.width : (parentRect.width || 400);

    state.views.forEach((view) => {
      if (!view) return;
      const aspect = getBuilderAspectForView(view);
      if (!aspect) return;
      let targetW = baseW;
      let targetH = Math.round(targetW / aspect);
      if (targetH > parentRect.height) {
        targetH = Math.min(parentRect.height, targetH);
        targetW = Math.round(targetH * aspect);
      }
      view.previewCanvasWidth = targetW;
      view.previewCanvasHeight = targetH;
    });
  }

  /** Base API URL without `/api/custom-quote` (same as download flow). */
  function getQuoteApiBase() {
    const ep = config.apiEndpoint || window.pcConfig?.apiEndpoint || '';
    return String(ep).replace(/\/api\/custom-quote\/?$/, '');
  }

  function buildCustomizationDataForQuoteApi() {
    return {
      viewportMobileScale: getViewportMobileScaleForApi(),
      views: views.map((view, idx) => {
        const viewState = state.views[idx];
        return {
          id: view.id,
          name: view.name,
          flipLayers: view.flipLayers,
          builderCanvasWidth: viewState.builderCanvasWidth ?? view.builderCanvasWidth,
          builderCanvasHeight: viewState.builderCanvasHeight ?? view.builderCanvasHeight,
          previewCanvasWidth: viewState.previewCanvasWidth,
          previewCanvasHeight: viewState.previewCanvasHeight,
          optionalLayersHidden: viewState.optionalLayersHidden || {},
          layers: view.layers.map(layer => ({
            id: layer.id,
            name: layer.name,
            image: layer.image,
            zIndex: layer.zIndex,
            defaultColor: layer.defaultColor,
            optional: layer.optional === true
          })),
          logo: view.logo,
          text1: view.text1,
          text2: view.text2,
          logoOrText: view.logoOrText || null,
          parts: viewState.parts,
          elements: {
            logo: viewState.elements.logo,
            text1: viewState.elements.text1,
            text2: viewState.elements.text2,
            logoOrText: viewState.elements.logoOrText || null
          }
        };
      })
    };
  }

  function buildLogoUrlsFromOrderAssetUploads(data, viewsList) {
    const logos = {};
    const uploads = (data && data.uploads) || {};
    viewsList.forEach((view) => {
      const candidates = [view.id, view.name].filter((x) => x != null && x !== '');
      let up = null;
      for (let i = 0; i < candidates.length; i++) {
        const k = candidates[i];
        up = uploads[k] || uploads[String(k)];
        if (up) break;
      }
      if (up && up.logo) {
        logos[view.name + '_logo'] = up.logo;
      }
    });
    return logos;
  }

  function quotePreflightPreviewsComplete(previews, viewsList) {
    if (!previews || !viewsList || viewsList.length === 0) return false;
    return viewsList.every((view) => {
      const k = String(view.name || view.id || 'view');
      const u = previews[k];
      return typeof u === 'string' && u.indexOf('https://') === 0;
    });
  }

  /** Smaller JSON over the wire when preflight already uploaded logos to Cloudinary. */
  function slimCustomizationPayloadForPreflightSubmit(data, pf) {
    if (!pf || !pf.logos || !data || !Array.isArray(data.views)) return data;
    const logos = pf.logos;
    const next = JSON.parse(JSON.stringify(data));
    next.views = next.views.map((view) => {
      if (!view.elements || !view.name) return view;
      const key = view.name + '_logo';
      const hasPreflightLogo = typeof logos[key] === 'string' && logos[key].indexOf('https://') === 0;
      if (!hasPreflightLogo) return view;
      const elements = Object.assign({}, view.elements);
      if (elements.logo && elements.logo.originalSrc) {
        elements.logo = Object.assign({}, elements.logo);
        delete elements.logo.originalSrc;
      }
      return Object.assign({}, view, { elements: elements });
    });
    return next;
  }

  const quotePreflightState = {
    customizationJson: null,
    previews: null,
    logos: null,
    promise: null,
    generation: 0
  };

  function invalidateQuotePreflight() {
    quotePreflightState.customizationJson = null;
    quotePreflightState.previews = null;
    quotePreflightState.logos = null;
    quotePreflightState.promise = null;
    quotePreflightState.generation++;
  }

  function startQuoteAssetPreflight() {
    // Disabled: the quote endpoint (/api/custom-quote) now renders previews + sends emails
    // asynchronously in the background after responding instantly. Running the preflight here
    // would render every view a second time on the server (wasted compute) for no UX gain,
    // since the customer no longer waits for rendering. Kept as a no-op for easy re-enable.
    return;
    /* eslint-disable no-unreachable */
    if (isPurchaseBag) return;
    const base = getQuoteApiBase();
    if (!base) return;
    const uploadUrl = base + '/api/customizer-upload-order-assets';
    const gen = ++quotePreflightState.generation;
    quotePreflightState.customizationJson = null;
    quotePreflightState.previews = null;
    quotePreflightState.logos = null;
    assignPreviewCanvasMetricsToAllViews();
    const customization = buildCustomizationDataForQuoteApi();
    const customizationJson = JSON.stringify(customization);
    const promise = (async () => {
      try {
        const res = await fetch(uploadUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            customization: customization,
            customizerId: window.pcConfig?.customiserId || null,
            includePreviews: true
          })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.success) {
          throw new Error((data && data.error) || 'preflight failed');
        }
        if (gen !== quotePreflightState.generation) return;
        quotePreflightState.customizationJson = customizationJson;
        quotePreflightState.previews = data.previews || {};
        quotePreflightState.logos = buildLogoUrlsFromOrderAssetUploads(data, views);
      } catch (e) {
        console.warn('[Quote preflight]', e && e.message ? e.message : e);
        if (gen === quotePreflightState.generation) {
          quotePreflightState.customizationJson = null;
          quotePreflightState.previews = null;
          quotePreflightState.logos = null;
        }
      } finally {
        if (gen === quotePreflightState.generation) {
          quotePreflightState.promise = null;
        }
      }
    })();
    quotePreflightState.promise = promise;
  }

  function isPointAllowedByMask(mask, xPercent, yPercent, rect) {
    if (!mask) return true;
    const px = Math.max(0, Math.min(mask.w - 1, Math.round((xPercent / 100) * mask.w)));
    const py = Math.max(0, Math.min(mask.h - 1, Math.round((yPercent / 100) * mask.h)));
    const idx = (py * mask.w + px) * 4;
    const r = mask.data[idx], g = mask.data[idx + 1], b = mask.data[idx + 2], a = mask.data[idx + 3];
    if (a >= 8) return true; // any visible pixel counts as printable
    // Fallback luminance test (for fully opaque JPGs without alpha)
    const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    // Consider very light backgrounds (near white/grey) as non-printable
    return lum < 0.95;
  }

  function generateTexts() {
    if (!textsContainer) return;
    textsContainer.innerHTML = '';
    const currentView = state.views[state.currentViewIndex];
    
    // Get canvas container dimensions for proportional scaling
    const canvasContainer = document.getElementById('pc-canvas');
    if (!canvasContainer) return;
    // Apply aspect lock before measuring for text placement
    ensureAspectCanvasForCurrentView();
    
    // Use requestAnimationFrame to ensure canvas is fully laid out before measuring
    requestAnimationFrame(() => {
      // Use getBoundingClientRect() for actual rendered dimensions
      const canvasRect = canvasContainer.getBoundingClientRect();
      let canvasWidth = canvasRect.width;
      let canvasHeight = canvasRect.height;
      
      // Fallback to offsetWidth if getBoundingClientRect fails
      if (!canvasWidth || canvasWidth <= 0) {
        canvasWidth = canvasContainer.offsetWidth || 400;
      }
      if (!canvasHeight || canvasHeight <= 0) {
        canvasHeight = canvasContainer.offsetHeight || 400;
      }
      
      // Ensure we have valid dimensions
      if (!canvasWidth || canvasWidth <= 0 || !canvasHeight || canvasHeight <= 0) {
        console.warn('[Customizer] Invalid canvas dimensions, retrying...');
        // Retry after a short delay if dimensions are invalid
        setTimeout(() => generateTexts(), 100);
        return;
      }
      
      // Reference canvas width (desktop max-width)
      const referenceCanvasWidth = 400;
      
      // Continue with text generation using the measured dimensions
      generateTextsWithDimensions(canvasWidth, canvasHeight, currentView, referenceCanvasWidth);
    });
  }
  
  function generateTextsWithDimensions(canvasWidth, canvasHeight, currentView, referenceCanvasWidth) {
    if (!textsContainer) return;
    
    [currentView.text1, currentView.text2].forEach((textConfig, idx) => {
      const textNum = idx + 1;
      const textState = currentView.elements[`text${textNum}`];
      
      // Check if text is enabled in backend config AND has an active state with content
      if (textConfig.enabled !== false && textState.active && textState.content) {
        const textDiv = document.createElement('div');
        textDiv.className = 'pc-text-element';
        textDiv.id = `pc-text-${textNum}-element`;
        textDiv.style.position = 'absolute';
        // Use defaults if values are undefined/null (positionX/Y default to 50%, rotation/skew default to 0)
        // Check both textConfig and textState for position values (textState may override config)
        const positionX = (textState.positionX != null) ? textState.positionX : ((textConfig.positionX != null) ? textConfig.positionX : 50);
        const positionY = (textState.positionY != null) ? textState.positionY : ((textConfig.positionY != null) ? textConfig.positionY : 50);
        const rotation = (textState.rotation != null) ? textState.rotation : ((textConfig.rotation != null) ? textConfig.rotation : 0);
        const skewX = (textState.skewX != null) ? textState.skewX : ((textConfig.skewX != null) ? textConfig.skewX : 0);
        const skewY = (textState.skewY != null) ? textState.skewY : ((textConfig.skewY != null) ? textConfig.skewY : 0);
        
        // Runtime log for builder vs storefront position mismatch debugging
        
        
        textDiv.style.left = positionX + '%';
        textDiv.style.top = positionY + '%';
        textDiv.style.transform = `translate(-50%, -50%) rotate(${rotation}deg) skew(${skewX}deg, ${skewY}deg)`;
        textDiv.style.zIndex = (1001 + idx).toString();
        textDiv.style.pointerEvents = 'none'; // Disable interaction
        
        // Scale font size proportionally to canvas width
        // Text size is stored as rem units, scale the rem value proportionally
        const baseFontSizeRem = textState.size || textConfig.size || 2;
        // Scale rem value proportionally to canvas width ratio
        // Apply mobile scaling factor (reduce size on mobile for better fit)
        const isMobile = window.innerWidth < 768;
        const mobileScaleFactor = isMobile ? 0.75 : 1; // 25% smaller on mobile
        const scaleRatio = (canvasWidth / referenceCanvasWidth) * mobileScaleFactor;
        const scaledFontSizeRem = baseFontSizeRem * scaleRatio;
        
        const textContent = document.createElement('div');
        textContent.className = 'pc-text-content';
        textContent.textContent = textState.content;
        const effectiveColor = (textConfig.linkedLayerId && currentView.parts[textConfig.linkedLayerId]) ? currentView.parts[textConfig.linkedLayerId] : (textState.color || textConfig.defaultColor);
        textContent.style.color = effectiveColor;
        textContent.style.fontSize = scaledFontSizeRem + 'rem';
        textDiv.appendChild(textContent);
        textsContainer.appendChild(textDiv);
      }
    });
    
    // Logo or Text slot (text mode)
    const lot = currentView.logoOrText;
    const lotState = currentView.elements.logoOrText;
    if (lot && lot.enabled && lotState && lotState.mode === 'text' && lotState.content && String(lotState.content).trim() !== '') {
      const canvasContainer = document.getElementById('pc-canvas');
      if (!canvasContainer) return;
      
      requestAnimationFrame(() => {
        const canvasRect = canvasContainer.getBoundingClientRect();
        let canvasWidth = canvasRect.width;
        if (!canvasWidth || canvasWidth <= 0) {
          canvasWidth = canvasContainer.offsetWidth || 400;
        }
        if (!canvasWidth || canvasWidth <= 0) {
          setTimeout(() => generateTexts(), 100);
          return;
        }
        const referenceCanvasWidth = 400;
        const textDiv = document.createElement('div');
        textDiv.className = 'pc-text-element pc-logoortext-element';
        textDiv.id = 'pc-logoortext-text-element';
        textDiv.style.position = 'absolute';
        textDiv.style.left = (lot.positionX ?? 50) + '%';
        textDiv.style.top = (lot.positionY ?? 55) + '%';
        textDiv.style.transform = `translate(-50%, -50%) rotate(${lot.rotation ?? 0}deg) skew(${lot.skewX ?? 0}deg, ${lot.skewY ?? 0}deg)`;
        textDiv.style.zIndex = '1003';
        textDiv.style.pointerEvents = 'none';
        const sizeText = lotState.size != null ? lotState.size : (lot.sizeText ?? 2);
        const isMobile = window.innerWidth < 768;
        const mobileScaleFactor = isMobile ? 0.75 : 1; // 25% smaller on mobile
        const scaleRatio = (canvasWidth / referenceCanvasWidth) * mobileScaleFactor;
        const scaledFontSizeRem = sizeText * scaleRatio;
        const effectiveColor = (lot.linkedLayerId && currentView.parts[lot.linkedLayerId]) ? currentView.parts[lot.linkedLayerId] : (lotState.color || lot.defaultColor || '#363636');
        const textContent = document.createElement('div');
        textContent.className = 'pc-text-content';
        textContent.textContent = lotState.content;
        textContent.style.color = effectiveColor;
        textContent.style.fontSize = scaledFontSizeRem + 'rem';
        textContent.style.fontWeight = 'bold';
        textDiv.appendChild(textContent);
        textsContainer.appendChild(textDiv);
      });
    }
  }

  function generateControls() {
    if (!controlsContainer) {
      console.error('controlsContainer not found');
      return;
    }
    // Sync linked colors before generating controls to ensure correct colors are displayed
    syncLinkedViewParts();
    // Sync any layers whose color is linked to a text color
    syncLayersLinkedToTextColors(state.views[state.currentViewIndex]);
    controlsContainer.innerHTML = '';
    if (isStandardColorsStage()) {
      state.currentViewIndex = 0;
    }
    const currentView = state.views[state.currentViewIndex];
    
    if (!currentView) {
      console.error('currentView not found at index', state.currentViewIndex);
      controlsContainer.innerHTML = '<p style="color: red; padding: 20px;">Error: View not found</p>';
      return;
    }
    
    const isMobile = false; /* mobile step-walk disabled: all controls shown in the scrolling panel */
    
    // Keep locked layer colors initialized even when color controls are hidden.
    if (currentView.layers && currentView.layers.length > 0) {
      currentView.layers.forEach((layer) => {
          if (!currentView.parts.hasOwnProperty(layer.id)) {
            currentView.parts[layer.id] = getLayerInitialColor(layer);
          }
      });
        }

    // Build unified steps array with all customization options.
    const steps = isStandardColorsStage()
      ? buildStandardColorSteps()
      : buildCustomizationStepsForView(currentView);

    const stageInfo = document.createElement('div');
    stageInfo.className = 'pc-section pc-stage-info';
    if (isStandardColorsStage()) {
      stageInfo.innerHTML = `
        <div class="pc-section-content" style="padding:12px;border:1px solid #e5e7eb;background:#f8fafc;">
          <strong>Step 1: Choose bag colors</strong><br>
          Pick colors once here. These colors will carry across your design, then you will move to logos and lettering.
        </div>
      `;
      controlsContainer.appendChild(stageInfo);
    } else if (isStandardCustomizeStage()) {
      stageInfo.innerHTML = `
        <div class="pc-section-content" style="padding:12px;border:1px solid #e5e7eb;background:#f8fafc;">
          <strong>Step 2: Add logos and lettering</strong><br>
          Switch views anytime to personalize each side. When ready, continue to the form to submit your quote request.
        </div>
      `;
      controlsContainer.appendChild(stageInfo);
    } else if (isPurchaseBag) {
      const fee = getPurchaseBagLetteringFeeTotal();
      stageInfo.innerHTML = `
        <div class="pc-section-content" style="padding:12px;border:1px solid #e5e7eb;background:#f8fafc;">
          <strong>Customize your bag</strong><br>
          Add logos and lettering, then add to cart when ready.
          <div style="margin-top:8px;font-weight:700;">Selected lettering strips: ${fee.strips}</div>
          <div style="font-weight:700;">Lettering total: $${fee.total}</div>
        </div>
      `;
      controlsContainer.appendChild(stageInfo);
    }

    // Step 1 (colors) and purchase bag: show each optional group once. Step 2 (customize): already set in step 1.
    if (isPurchaseBag || isStandardColorsStage()) {
      appendOptionalLayerControlsDeduped(controlsContainer);
    }
    
    // Initialize mobile step state
    if (isMobile) {
      if (!state.mobileCustomizationStep) {
        state.mobileCustomizationStep = 0;
      }
    }
    
    // Mobile: Step-by-step interface for all options
    if (isMobile && steps.length > 0) {
      // Create main container
      const mainContainer = document.createElement('div');
      mainContainer.className = 'pc-mobile-steps-container';
      
      // Progress indicator
      const progressDiv = document.createElement('div');
      progressDiv.className = 'pc-layer-progress';
      progressDiv.id = 'pc-mobile-progress';
      const currentStep = steps[state.mobileCustomizationStep];
      let stepName = '';
      if (currentStep.type === 'layer') {
        const v = currentStep.viewId ? state.views.find(x => x.id === currentStep.viewId) : null;
        const viewName = v?.name ? String(v.name) : '';
        const layerName = currentStep.data?.name || 'Layer';
        stepName = viewName ? `${viewName}: ${layerName}` : layerName;
      }
      else if (currentStep.type === 'logo') stepName = 'Logo';
      else if (currentStep.type === 'text') stepName = `Text ${currentStep.num}`;
      else if (currentStep.type === 'logoOrText') stepName = 'Logo or Text';
      progressDiv.textContent = `${stepName} (${state.mobileCustomizationStep + 1} of ${steps.length})`;
      mainContainer.appendChild(progressDiv);
      
      // Steps container
      const stepsContainer = document.createElement('div');
      stepsContainer.id = 'pc-mobile-steps-container';
      mainContainer.appendChild(stepsContainer);

      
      // Create each step
      steps.forEach((step, index) => {
        const stepDiv = document.createElement('div');
        stepDiv.className = 'pc-customization-step' + (index === state.mobileCustomizationStep ? ' active' : '');
        stepDiv.setAttribute('data-step-index', index);
        
        if (step.type === 'layer') {
          // Layer step
          const layer = step.data;
          const stepView = step.viewId ? state.views.find(v => v.id === step.viewId) : currentView;
          if (!stepView) return;
          if (!stepView.parts.hasOwnProperty(layer.id)) stepView.parts[layer.id] = getLayerInitialColor(layer);
          
          const headerDiv = document.createElement('div');
          headerDiv.style.cssText = 'display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;';
          
          const nameLabel = document.createElement('label');
          nameLabel.className = 'pc-label';
          nameLabel.style.cssText = 'font-size: 1.1rem; font-weight: 700; margin-bottom: 0; display: flex; align-items: center; gap: 6px; color: #111;';
          
          const currentColorHex = (stepView.parts[layer.id] || getLayerBaseColor(layer)).toUpperCase();
          const currentColorObj = BRAND_COLORS.find(c => c.hex.toUpperCase() === currentColorHex);
          const currentColorName = currentColorObj ? currentColorObj.name : 'Unknown';
          
          // Check if layer is linked to another layer
          const isLinked = layer.linkedLayerId && layer.linkedLayerId.includes(':');
          if (isLinked) {
            const [targetViewId, targetLayerId] = layer.linkedLayerId.split(':');
            const targetView = views.find(v => v.id === targetViewId);
            const targetLayer = targetView?.layers?.find(l => l.id === targetLayerId);
            const linkText = targetView && targetLayer 
              ? `🔗 Linked to ${targetView.name} → ${targetLayer.name || 'Unnamed Layer'}`
              : '🔗 Linked';
            
            const linkIcon = document.createElement('span');
            linkIcon.textContent = '🔗';
            linkIcon.title = linkText;
            linkIcon.style.cssText = 'font-size: 0.9rem; opacity: 0.7; cursor: help;';
            nameLabel.appendChild(linkIcon);
          }
          
          const nameText = document.createTextNode(`${layer.name || 'Unnamed Layer'} (${currentColorName})`);
          nameLabel.appendChild(nameText);
          // Store reference to the text node for easy updates
          nameLabel.dataset.textNodeIndex = nameLabel.childNodes.length - 1;
          headerDiv.appendChild(nameLabel);
          
          const labelDiv = document.createElement('div');
          labelDiv.style.cssText = 'margin-bottom: 8px; font-size: 0.85rem; color: #666;';
          labelDiv.textContent = 'Select a color:';
          
          const colorGrid = document.createElement('div');
          colorGrid.className = 'pc-color-grid';
          colorGrid.setAttribute('data-layer-id', layer.id);
          colorGrid.style.cssText = 'margin-top: 8px; width: 100%;';
          
          const currentColor = (stepView.parts[layer.id] || getLayerBaseColor(layer)).toUpperCase();
          
          if (typeof BRAND_COLORS !== 'undefined' && Array.isArray(BRAND_COLORS) && BRAND_COLORS.length > 0) {
            BRAND_COLORS.forEach((color) => {
              const swatch = document.createElement('div');
              const colorHexUpper = color.hex.toUpperCase();
              const isActive = currentColor === colorHexUpper;
              swatch.className = 'pc-color-swatch-item' + (isActive ? ' active' : '');
              swatch.style.cssText = `
                aspect-ratio: 1;
                border-radius: 0;
                border: ${isActive ? '3px solid #000' : '2px solid transparent'};
                cursor: pointer;
                transition: all 0.2s ease;
                background-color: ${color.hex};
                display: block;
              `;
              swatch.title = `${color.name} (${color.hex})`;
              swatch.setAttribute('data-color-hex', color.hex);
              swatch.setAttribute('data-color-name', color.name);
              
              swatch.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                stepView.parts[layer.id] = color.hex;
                // Ensure we use the canonical pipeline (link cascades + filter updates)
                const prevIdx = state.currentViewIndex;
                const stepIdx = state.views.findIndex(v => v?.id === stepView?.id);
                if (stepIdx >= 0) state.currentViewIndex = stepIdx;
                updateLayerColor(layer.id, color.hex);
                state.currentViewIndex = prevIdx;
                colorGrid.querySelectorAll('.pc-color-swatch-item').forEach(s => {
                  s.classList.remove('active');
                  s.style.borderColor = 'transparent';
                  s.style.borderWidth = '2px';
                });
                swatch.classList.add('active');
                swatch.style.borderColor = '#000';
                swatch.style.borderWidth = '3px';
                // Update the text node (last child, after link icon if present)
                const textNodeIndex = parseInt(nameLabel.dataset.textNodeIndex || '0', 10);
                const textNode = nameLabel.childNodes[textNodeIndex];
                if (textNode && textNode.nodeType === Node.TEXT_NODE) {
                  textNode.textContent = `${layer.name || 'Unnamed Layer'} (${color.name})`;
                } else {
                  // Fallback: update last text node
                  const textNodes = Array.from(nameLabel.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
                  if (textNodes.length > 0) {
                    textNodes[textNodes.length - 1].textContent = `${layer.name || 'Unnamed Layer'} (${color.name})`;
                  }
                }
                updateNextButtonState();
                generateViewToggle();
              });
              
              colorGrid.appendChild(swatch);
            });
          }
          
          stepDiv.appendChild(headerDiv);
          stepDiv.appendChild(labelDiv);
          stepDiv.appendChild(colorGrid);
          
        } else if (step.type === 'logo') {
          // Logo step
          const logoHeader = document.createElement('div');
          logoHeader.className = 'pc-section-header';
          logoHeader.style.cssText = 'display: flex; align-items: center; gap: 8px; margin-bottom: 12px;';
          logoHeader.innerHTML = '<h4 class="pc-heading">Logo</h4><span class="pc-info-icon" data-tooltip="Upload a clean logo: PNG, JPG, SVG, WebP, GIF, TIFF, HEIC, ICO, or BMP. Remove Background works best on solid-color backdrops (not typical for SVG)."><img src="https://cdn.shopify.com/s/files/1/1569/7559/files/icons8-info-50.png?v=1770298321" alt="Info" /></span>';
          stepDiv.appendChild(logoHeader);
          
          const logoContent = document.createElement('div');
          logoContent.className = 'pc-section-content';
          logoContent.innerHTML = `
            <p style="margin:0 0 8px;font-size:0.85rem;color:#4b5563;">Tip: Upload your logo, then use <strong>Remove Background</strong> if needed for a cleaner look.</p>
            <label class="pc-label">Upload Logo</label>
            <input type="file" id="pc-logo-upload-mobile" accept="${LOGO_IMAGE_ACCEPT}" class="pc-input" style="margin-bottom: 10px;">
            <div id="pc-logo-tools-mobile" style="display:none; gap: 10px; margin-bottom:10px; flex-wrap:wrap;">
              <button id="pc-remove-bg-btn-mobile" class="pc-btn-sm" type="button">Remove Background (Optional)</button>
              <button id="pc-reset-logo-btn-mobile" class="pc-btn-sm" type="button">Reset</button>
            </div>
            <button id="pc-remove-logo-btn-mobile" style="color:red; background:none; border:none; cursor:pointer; display:none; margin-bottom:10px;">Remove Logo</button>
            <div id="pc-logo-preview-mobile"></div>
            <div style="margin-top: 10px;">
              <label class="pc-label-sm">Logo Size</label>
              <input type="range" id="pc-logo-size-mobile" min="50" max="300" value="${currentView.logo.size || 150}" class="pc-range-input">
            </div>
          `;
          stepDiv.appendChild(logoContent);
          
          // Setup logo event listeners
          setTimeout(() => {
            const logoUpload = stepDiv.querySelector('#pc-logo-upload-mobile');
            const logoTools = stepDiv.querySelector('#pc-logo-tools-mobile');
            const removeLogoBtn = stepDiv.querySelector('#pc-remove-logo-btn-mobile');
            const removeBgBtn = stepDiv.querySelector('#pc-remove-bg-btn-mobile');
            const resetLogoBtn = stepDiv.querySelector('#pc-reset-logo-btn-mobile');
            const logoSizeInput = stepDiv.querySelector('#pc-logo-size-mobile');
            
            if (logoUpload) {
              logoUpload.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (file) {
                  if (!isAllowedLogoImageFile(file)) {
                    showToast('Please choose a supported image (PNG, JPG, SVG, WebP, GIF, TIFF, HEIC, etc.)');
                    e.target.value = '';
                    return;
                  }
                  const reader = new FileReader();
                  reader.onload = (event) => {
                    currentView.elements.logo.active = true;
                    currentView.elements.logo.src = event.target.result;
                    currentView.elements.logo.originalSrc = event.target.result;
                    if (logoTools) logoTools.style.display = 'flex';
                    if (removeLogoBtn) removeLogoBtn.style.display = 'inline-block';
                    generateLogos();
                    updateNextButtonState();
                    generateViewToggle();
                  };
                  reader.readAsDataURL(file);
                }
              });
            }
            
            if (removeLogoBtn) {
              removeLogoBtn.addEventListener('click', () => {
                currentView.elements.logo.active = false;
                currentView.elements.logo.src = null;
                currentView.elements.logo.originalSrc = null;
                if (logoTools) logoTools.style.display = 'none';
                removeLogoBtn.style.display = 'none';
                if (logoUpload) logoUpload.value = '';
                generateLogos();
                updateNextButtonState();
                generateViewToggle();
              });
            }
            
            if (logoSizeInput) {
              logoSizeInput.addEventListener('input', (e) => {
                currentView.elements.logo.size = parseInt(e.target.value, 10);
                generateLogos();
              });
            }
            
            if (removeBgBtn) {
              removeBgBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                if (!currentView.elements.logo.active || !currentView.elements.logo.src) return;
                removeBgBtn.textContent = 'Processing...';
                removeBgBtn.disabled = true;
                try {
                  await removeOuterBackground(currentView.elements.logo.src, (newSrc) => {
                    currentView.elements.logo.src = newSrc;
                    generateLogos();
                    removeBgBtn.textContent = 'Remove Background';
                    removeBgBtn.disabled = false;
                    updateNextButtonState();
                  });
                } catch (err) {
                  console.error('Background removal failed:', err);
                  removeBgBtn.textContent = 'Remove Background';
                  removeBgBtn.disabled = false;
                }
              });
            }
            
            if (resetLogoBtn) {
              resetLogoBtn.addEventListener('click', () => {
                if (currentView.elements.logo.originalSrc) {
                  currentView.elements.logo.src = currentView.elements.logo.originalSrc;
                  generateLogos();
                }
              });
            }
          }, 100);
          
        } else if (step.type === 'text') {
          // Text step
          const textNum = step.num;
          const textConfig = step.data;
          const lockContent = isTextContentLocked(textConfig);
          const requiresPaidOptIn = shouldRequirePaidTextOptIn(textConfig);
          const paidOptIn = requiresPaidOptIn ? ensurePaidTextOptInState(currentView, textNum) : true;
          if (lockContent) {
            const lockedValue = getLockedTextValue(textConfig);
            currentView.elements[`text${textNum}`].content = lockedValue;
            currentView.elements[`text${textNum}`].active = String(lockedValue).trim() !== '';
          }
          const effectiveColor = (textConfig.linkedLayerId && currentView.parts[textConfig.linkedLayerId]) ? currentView.parts[textConfig.linkedLayerId] : (currentView.elements[`text${textNum}`].color || textConfig.defaultColor);
          const colorDisabled = textConfig.linkedLayerId ? ' disabled' : '';
          const readonlyAttr = lockContent ? ' readonly title="This text is fixed by admin"' : '';
          const textDisabledAttr = requiresPaidOptIn && !paidOptIn ? ' disabled' : '';
          const paidOptInHTML = requiresPaidOptIn ? `
            <label class="pc-label" style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
              <input type="checkbox" id="pc-text-${textNum}-paid-optin-mobile" ${paidOptIn ? 'checked' : ''}>
              <span>Add customisation for $12</span>
            </label>
          ` : '';
          const textInputHTML = lockContent ? '' : `
            ${paidOptInHTML}
            <label class="pc-label">Text Content</label>
            <input type="text" id="pc-text-${textNum}-input-mobile" class="pc-input" placeholder="${textConfig.placeholder || 'Enter text...'}" value="${currentView.elements[`text${textNum}`].content || ''}"${readonlyAttr}${textDisabledAttr}>
          `;
          
          const textHeader = document.createElement('div');
          textHeader.className = 'pc-section-header';
          textHeader.style.cssText = 'display: flex; align-items: center; gap: 8px; margin-bottom: 12px;';
          textHeader.innerHTML = `<h4 class="pc-heading">Text ${textNum}</h4><span class="pc-info-icon" data-tooltip="Enter custom text to personalize your design. You can change the color and adjust the size using the controls below."><img src="https://cdn.shopify.com/s/files/1/1569/7559/files/icons8-info-50.png?v=1770298321" alt="Info" /></span>`;
          stepDiv.appendChild(textHeader);
          
          let colorOptionsHTML = '';
          BRAND_COLORS.forEach(color => {
            const selected = (effectiveColor && color.hex.toUpperCase() === effectiveColor.toUpperCase()) ? ' selected' : '';
            colorOptionsHTML += `<option value="${color.hex}"${selected}>${color.name}</option>`;
          });
          
          // If this text is linked to a layer, show the layer-style swatches (same palette as layer colors).
          const linkedLayer = textConfig.linkedLayerId ? (currentView.layers || []).find(l => l.id === textConfig.linkedLayerId) : null;
          const linkedLayerName = linkedLayer?.name ? String(linkedLayer.name) : 'layer';
          let linkedLayerSwatchesHTML = '';
          if (textConfig.linkedLayerId) {
            const currentHex = (effectiveColor || '').toString().toUpperCase();
            linkedLayerSwatchesHTML = `
              <div class="pc-label" style="margin-top:8px;">Color (linked to ${linkedLayerName})</div>
              <div class="pc-color-grid" data-linked-layer-id="${textConfig.linkedLayerId}" style="margin-top:8px; width:100%;">
                ${BRAND_COLORS.map((c) => {
                  const isActive = currentHex && c.hex.toUpperCase() === currentHex;
                  return `<div class="pc-color-swatch-item${isActive ? ' active' : ''}" data-color-hex="${c.hex}" title="${c.name} (${c.hex})" style="aspect-ratio:1;border-radius:0;border:${isActive ? '3px solid #000' : '2px solid transparent'};cursor:pointer;transition:all 0.2s ease;background-color:${c.hex};display:block;"></div>`;
                }).join('')}
              </div>
              <div class="pc-help" style="margin:6px 0 10px;color:#6b7280;font-size:0.85rem;">This picker controls the linked layer color for this view.</div>
            `;
          }
          
          const textContent = document.createElement('div');
          textContent.className = 'pc-section-content';
          textContent.innerHTML = `
            <p style="margin:0 0 8px;font-size:0.85rem;color:#4b5563;">Text ${textNum} is optional. Enter exactly what you want printed and choose a color/size that stands out.</p>
            ${textInputHTML}
            ${textConfig.linkedLayerId ? linkedLayerSwatchesHTML : `
              <label class="pc-label">Color</label>
              <select id="pc-text-${textNum}-color-mobile" class="pc-select" style="height:46px;">
              ${colorOptionsHTML}
            </select>
            `}
          <div style="margin-top: 10px;">
            <label class="pc-label-sm">Text Size</label>
            <input type="range"
              id="pc-text-${textNum}-size-mobile"
              min="${(textConfig.sizeMin != null ? textConfig.sizeMin : 1)}"
              max="${(textConfig.sizeMax != null ? textConfig.sizeMax : 5)}"
              step="0.1"
              value="${currentView.elements[`text${textNum}`].size || textConfig.sizeDefault || textConfig.size || 2}"
              class="pc-range-input">
          </div>
          `;
          stepDiv.appendChild(textContent);
          
          // Setup text event listeners
          setTimeout(() => {
            const textInput = stepDiv.querySelector(`#pc-text-${textNum}-input-mobile`);
            const colorSelect = stepDiv.querySelector(`#pc-text-${textNum}-color-mobile`);
            const sizeInput = stepDiv.querySelector(`#pc-text-${textNum}-size-mobile`);
            const paidOptInInput = stepDiv.querySelector(`#pc-text-${textNum}-paid-optin-mobile`);
            const linkedSwatchGrid = stepDiv.querySelector(`.pc-color-grid[data-linked-layer-id="${textConfig.linkedLayerId || ''}"]`);

            if (paidOptInInput) {
              paidOptInInput.addEventListener('change', (e) => {
                currentView.elements[`text${textNum}`].paidOptIn = !!e.target.checked;
                if (!enforcePurchaseBagPaidOptInLimit(e.target, currentView, textNum)) {
                  return;
                }
                if (!e.target.checked) {
                  currentView.elements[`text${textNum}`].active = false;
                  currentView.elements[`text${textNum}`].content = '';
                }
                generateControls();
                generateTexts();
                updateNextButtonState();
                generateViewToggle();
              });
            }
            
            if (textInput) {
              textInput.addEventListener('input', (e) => {
                if (lockContent) return;
                if (requiresPaidOptIn && !currentView.elements[`text${textNum}`].paidOptIn) return;
                if (textConfig.enabled !== false) {
                  currentView.elements[`text${textNum}`].active = e.target.value.length > 0;
                  currentView.elements[`text${textNum}`].content = e.target.value;
                  generateTexts();
                  updateNextButtonState();
                  generateViewToggle();
                }
              });
            }
            
            if (colorSelect) {
              colorSelect.addEventListener('change', (e) => {
                const next = e.target.value;
                currentView.elements[`text${textNum}`].color = next;
                // If text color is linked to a layer, recolor that layer too.
                if (textConfig.linkedLayerId) {
                  updateLayerColor(textConfig.linkedLayerId, next);
                }
                generateTexts();
                updateNextButtonState();
              });
            }
            
            if (linkedSwatchGrid && textConfig.linkedLayerId) {
              linkedSwatchGrid.querySelectorAll('.pc-color-swatch-item').forEach((swatch) => {
                swatch.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const next = swatch.getAttribute('data-color-hex');
                  if (!next) return;
                  currentView.elements[`text${textNum}`].color = next;
                  updateLayerColor(textConfig.linkedLayerId, next);
                  generateControls();
                  generateTexts();
                  updateNextButtonState();
                });
              });
            }
            
            if (sizeInput) {
              sizeInput.addEventListener('input', (e) => {
                currentView.elements[`text${textNum}`].size = parseFloat(e.target.value);
                generateTexts();
                updateNextButtonState();
              });
            }
          }, 100);
        } else if (step.type === 'logoOrText') {
          const lotConfig = step.data;
          const lotState = currentView.elements.logoOrText;
          const mode = (lotState && lotState.mode) || 'text';
          const toggleDiv = document.createElement('div');
          toggleDiv.style.cssText = 'margin-bottom: 12px; display: flex; gap: 8px;';
          const btnLogo = document.createElement('button');
          btnLogo.type = 'button';
          btnLogo.className = 'pc-btn-sm' + (mode === 'logo' ? ' pc-btn-primary' : '');
          btnLogo.textContent = 'Logo';
          const btnText = document.createElement('button');
          btnText.type = 'button';
          btnText.className = 'pc-btn-sm' + (mode === 'text' ? ' pc-btn-primary' : '');
          btnText.textContent = 'Text';
          btnLogo.addEventListener('click', () => {
            currentView.elements.logoOrText.mode = 'logo';
            btnLogo.classList.add('pc-btn-primary');
            btnText.classList.remove('pc-btn-primary');
            generateControls();
            generateLogos();
            generateTexts();
            updateNextButtonState();
          });
          btnText.addEventListener('click', () => {
            currentView.elements.logoOrText.mode = 'text';
            btnText.classList.add('pc-btn-primary');
            btnLogo.classList.remove('pc-btn-primary');
            generateControls();
            generateLogos();
            generateTexts();
            updateNextButtonState();
          });
          toggleDiv.appendChild(btnLogo);
          toggleDiv.appendChild(btnText);
          stepDiv.appendChild(toggleDiv);
          const contentDiv = document.createElement('div');
          contentDiv.className = 'pc-section-content';
          contentDiv.id = 'pc-lot-mobile-content';
          stepDiv.appendChild(contentDiv);
          if (mode === 'logo') {
            contentDiv.innerHTML = `
              <label class="pc-label">Upload Logo</label>
              <input type="file" id="pc-lot-logo-upload-mobile" accept="${LOGO_IMAGE_ACCEPT}" class="pc-input" style="margin-bottom:10px;">
              <button id="pc-lot-remove-logo-mobile" style="color:red;background:none;border:none;cursor:pointer;display:none;margin-bottom:10px;">Remove Logo</button>
              <div style="margin-top:10px;"><label class="pc-label-sm">Logo Size (px)</label><input type="range" id="pc-lot-size-mobile" min="50" max="300" value="${lotConfig.sizeLogo ?? 150}" class="pc-range-input"></div>
            `;
            setTimeout(() => {
              const upload = contentDiv.querySelector('#pc-lot-logo-upload-mobile');
              const removeBtn = contentDiv.querySelector('#pc-lot-remove-logo-mobile');
              const sizeInput = contentDiv.querySelector('#pc-lot-size-mobile');
              if (upload) upload.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (file) {
                  if (!isAllowedLogoImageFile(file)) {
                    showToast('Please choose a supported image (PNG, JPG, SVG, WebP, GIF, TIFF, HEIC, etc.)');
                    e.target.value = '';
                    return;
                  }
                  const reader = new FileReader();
                  reader.onload = (ev) => {
                    currentView.elements.logoOrText.logo = { active: true, src: ev.target.result, originalSrc: ev.target.result };
                    if (removeBtn) removeBtn.style.display = 'inline-block';
                    generateLogos();
                    updateNextButtonState();
                    generateViewToggle();
                  };
                  reader.readAsDataURL(file);
                }
              });
              if (removeBtn) removeBtn.addEventListener('click', () => {
                currentView.elements.logoOrText.logo = { active: false, src: null, originalSrc: null };
                removeBtn.style.display = 'none';
                if (upload) upload.value = '';
                generateLogos();
                updateNextButtonState();
                generateViewToggle();
              });
              if (sizeInput) sizeInput.addEventListener('input', (e) => {
                const px = parseInt(e.target.value, 10);
                if (!isNaN(px)) { currentView.elements.logoOrText.logoSize = px; generateLogos(); }
              });
            }, 50);
          } else {
            let colorOpts = '';
            const effectiveColor = (lotConfig.linkedLayerId && currentView.parts[lotConfig.linkedLayerId]) ? currentView.parts[lotConfig.linkedLayerId] : (lotState.color || lotConfig.defaultColor || '#363636');
            BRAND_COLORS.forEach(c => { colorOpts += `<option value="${c.hex}"${c.hex === effectiveColor ? ' selected' : ''}>${c.name}</option>`; });
            contentDiv.innerHTML = `
              <label class="pc-label">Text Content</label>
              <input type="text" id="pc-lot-text-input-mobile" class="pc-input" placeholder="${lotConfig.placeholder || 'Logo or text...'}" value="${(lotState && lotState.content) || ''}">
              <label class="pc-label">Color</label>
              <select id="pc-lot-color-mobile" class="pc-select" style="height:46px;" ${lotConfig.linkedLayerId ? 'disabled' : ''}>${colorOpts}</select>
              <div style="margin-top:10px;"><label class="pc-label-sm">Text Size (rem)</label><input type="range" id="pc-lot-textsize-mobile" min="${lotConfig.sizeTextMin ?? 1}" max="${lotConfig.sizeTextMax ?? 5}" step="0.1" value="${(lotState && lotState.size != null) ? lotState.size : (lotConfig.sizeTextDefault ?? lotConfig.sizeText ?? 2)}" class="pc-range-input"></div>
            `;
            setTimeout(() => {
              const textInput = contentDiv.querySelector('#pc-lot-text-input-mobile');
              const colorSelect = contentDiv.querySelector('#pc-lot-color-mobile');
              const sizeInput = contentDiv.querySelector('#pc-lot-textsize-mobile');
              if (textInput) textInput.addEventListener('input', (e) => {
                currentView.elements.logoOrText.content = e.target.value;
                generateTexts();
                updateNextButtonState();
                generateViewToggle();
              });
              if (colorSelect && !lotConfig.linkedLayerId) colorSelect.addEventListener('change', (e) => {
                currentView.elements.logoOrText.color = e.target.value;
                generateTexts();
              });
              if (sizeInput) sizeInput.addEventListener('input', (e) => {
                currentView.elements.logoOrText.size = parseFloat(e.target.value);
                generateTexts();
              });
            }, 50);
          }
        }
        
        stepsContainer.appendChild(stepDiv);
      });
      
      // Navigation buttons - HIDDEN on mobile, using main "Next" button instead
      // The main "Next" button (pc-to-step-2) will handle cycling through steps
      const navDiv = document.createElement('div');
      navDiv.className = 'pc-layer-nav';
      navDiv.id = 'pc-mobile-nav';
      navDiv.style.display = 'none'; // Hide the Previous/Next buttons, use main Next button instead
      
      // Keep navDiv structure for updateMobileCustomizationStep function compatibility
      const prevBtn = document.createElement('button');
      prevBtn.className = 'pc-layer-nav-btn secondary';
      prevBtn.textContent = 'Previous';
      prevBtn.disabled = state.mobileCustomizationStep === 0;
      
      const nextBtn = document.createElement('button');
      nextBtn.className = 'pc-layer-nav-btn';
      nextBtn.textContent = state.mobileCustomizationStep === steps.length - 1 ? 'Done' : 'Next';
      nextBtn.disabled = false;
      
      navDiv.appendChild(prevBtn);
      navDiv.appendChild(nextBtn);
      mainContainer.appendChild(navDiv);
      
      controlsContainer.appendChild(mainContainer);
      
      // Function to update mobile step display
      window.updateMobileCustomizationStep = function() {
        const stepElements = stepsContainer.querySelectorAll('.pc-customization-step');
        const progress = document.getElementById('pc-mobile-progress');
        const prevBtn = navDiv.querySelector('.pc-layer-nav-btn.secondary');
        const nextBtn = navDiv.querySelector('.pc-layer-nav-btn:not(.secondary)');
        
        stepElements.forEach((stepEl, idx) => {
          if (idx === state.mobileCustomizationStep) {
            stepEl.classList.add('active');
          } else {
            stepEl.classList.remove('active');
          }
        });
        
        if (progress) {
          const currentStep = steps[state.mobileCustomizationStep];
          let stepName = '';
          if (currentStep.type === 'layer') {
            const v = currentStep.viewId ? state.views.find(x => x.id === currentStep.viewId) : null;
            const viewName = v?.name ? String(v.name) : '';
            const layerName = currentStep.data?.name || 'Layer';
            stepName = viewName ? `${viewName}: ${layerName}` : layerName;
          }
          else if (currentStep.type === 'logo') stepName = 'Logo';
          else if (currentStep.type === 'text') stepName = `Text ${currentStep.num}`;
          else if (currentStep.type === 'logoOrText') stepName = 'Logo or Text';
          progress.textContent = `${stepName} (${state.mobileCustomizationStep + 1} of ${steps.length})`;
        }
        
        if (prevBtn) {
          prevBtn.disabled = state.mobileCustomizationStep === 0;
        }
        
        if (nextBtn) {
          nextBtn.textContent = state.mobileCustomizationStep === steps.length - 1 ? 'Done' : 'Next';
        }
        
        // Update main Back button visibility
        updateNextButtonState();
        
        controlsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      
      // Initialize first step
      updateMobileCustomizationStep();
      
    } else {
      // Desktop: Show all options at once
      
      // Layers section
    if (!isPurchaseBag && isStandardColorsStage()) {
        const layersSection = document.createElement('div');
        layersSection.className = 'pc-section';
        const layersHeader = document.createElement('div');
        layersHeader.className = 'pc-section-header';
        layersHeader.style.cssText = 'display: flex; align-items: center; gap: 8px;';
        layersHeader.innerHTML = '<h4 class="pc-heading">Layers</h4><span class="pc-info-icon" data-tooltip="Select colors for each layer to customize the appearance. Click on a color swatch to apply it to the layer."><img src="https://cdn.shopify.com/s/files/1/1569/7559/files/icons8-info-50.png?v=1770298321" alt="Info" /></span>';
        layersSection.appendChild(layersHeader);
        const layersContent = document.createElement('div');
        layersContent.className = 'pc-section-content';
        layersContent.id = 'pc-layers-controls';
        layersSection.appendChild(layersContent);
        controlsContainer.appendChild(layersSection);
        
        const colorSteps = buildStandardColorSteps();
        colorSteps.forEach((step) => {
          const stepView = state.views.find(v => v.id === step.viewId);
          const layer = step.data;
          if (!stepView || !layer) return;
          if (!stepView.parts.hasOwnProperty(layer.id)) stepView.parts[layer.id] = getLayerInitialColor(layer);
          
          const layerDiv = document.createElement('div');
          layerDiv.style.marginBottom = '20px';
          layerDiv.style.paddingBottom = '15px';
          layerDiv.style.borderBottom = '1px solid #eee';
          
          const headerDiv = document.createElement('div');
          headerDiv.style.cssText = 'display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;';
          
          const nameLabel = document.createElement('label');
          nameLabel.className = 'pc-label';
          nameLabel.style.cssText = 'font-size: 1rem; font-weight: 700; margin-bottom: 0; display: flex; align-items: center; gap: 6px; color: #111;';
          
          const currentColorHex = (stepView.parts[layer.id] || getLayerBaseColor(layer)).toUpperCase();
          const currentColorObj = BRAND_COLORS.find(c => c.hex.toUpperCase() === currentColorHex);
          const currentColorName = currentColorObj ? currentColorObj.name : 'Unknown';
          
          // Check if layer is linked to another layer
          const isLinked = layer.linkedLayerId && layer.linkedLayerId.includes(':');
          if (isLinked) {
            const [targetViewId, targetLayerId] = layer.linkedLayerId.split(':');
            const targetView = views.find(v => v.id === targetViewId);
            const targetLayer = targetView?.layers?.find(l => l.id === targetLayerId);
            const linkText = targetView && targetLayer 
              ? `🔗 Linked to ${targetView.name} → ${targetLayer.name || 'Unnamed Layer'}`
              : '🔗 Linked';
            
            const linkIcon = document.createElement('span');
            linkIcon.textContent = '🔗';
            linkIcon.title = linkText;
            linkIcon.style.cssText = 'font-size: 0.9rem; opacity: 0.7; cursor: help;';
            nameLabel.appendChild(linkIcon);
          }
          
          const viewPrefix = stepView?.name ? `${stepView.name}: ` : '';
          const nameText = document.createTextNode(`${viewPrefix}${layer.name || 'Unnamed Layer'} (${currentColorName})`);
          nameLabel.appendChild(nameText);
          headerDiv.appendChild(nameLabel);

          // Optional part: inline enable/disable checkbox on the Colours step
          const _pcIsOptional = layer.optional === true;
          if (_pcIsOptional) {
            const _pcOptCb = document.createElement('input');
            _pcOptCb.type = 'checkbox';
            _pcOptCb.className = 'pc-optional-layer-checkbox pc-color-part-toggle';
            _pcOptCb.checked = !isOptionalLayerHidden(stepView, layer);
            _pcOptCb.setAttribute('aria-label', 'Include ' + (layer.name || 'this part'));
            _pcOptCb.title = _pcOptCb.checked ? 'Uncheck to remove this part' : 'Check to add this part';
            _pcOptCb.addEventListener('change', function () {
              setOptionalHiddenForEquivGroup(stepView, layer, !_pcOptCb.checked);
              generateLayers();
              generateTexts();
              generateLogos();
              generateControls();
              updateNextButtonState();
              generateViewToggle();
            });
            headerDiv.appendChild(_pcOptCb);
          }
          
          const labelDiv = document.createElement('div');
          labelDiv.style.cssText = 'margin-bottom: 8px; font-size: 0.85rem; color: #666;';
          labelDiv.textContent = 'Select a color:';
          
          const colorGrid = document.createElement('div');
          colorGrid.className = 'pc-color-grid';
          colorGrid.setAttribute('data-layer-id', layer.id);
          colorGrid.style.cssText = 'margin-top: 8px; width: 100%;';
          
          const currentColor = (stepView.parts[layer.id] || getLayerBaseColor(layer)).toUpperCase();
          
          if (typeof BRAND_COLORS !== 'undefined' && Array.isArray(BRAND_COLORS) && BRAND_COLORS.length > 0) {
            BRAND_COLORS.forEach((color) => {
              const swatch = document.createElement('div');
              const colorHexUpper = color.hex.toUpperCase();
              const isActive = currentColor === colorHexUpper;
              swatch.className = 'pc-color-swatch-item' + (isActive ? ' active' : '');
              const borderWidth = isActive ? '4px' : '3px';
              const borderColor = isActive ? '#000' : 'transparent';
              swatch.style.cssText = `
                aspect-ratio: 1;
                border-radius: 0;
                border: ${borderWidth} solid ${borderColor};
                cursor: pointer;
                transition: all 0.2s ease;
                min-height: 44px;
                min-width: 44px;
                width: 100%;
                height: auto;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                background-color: ${color.hex};
                display: block;
              `;
              swatch.title = `${color.name} (${color.hex})`;
              swatch.setAttribute('data-color-hex', color.hex);
              swatch.setAttribute('data-color-name', color.name);
              
              swatch.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                stepView.parts[layer.id] = color.hex;
                // Ensure we use the canonical pipeline (link cascades + filter updates)
                const prevIdx = state.currentViewIndex;
                const stepIdx = state.views.findIndex(v => v?.id === stepView?.id);
                if (stepIdx >= 0) state.currentViewIndex = stepIdx;
                updateLayerColor(layer.id, color.hex);
                state.currentViewIndex = prevIdx;
                colorGrid.querySelectorAll('.pc-color-swatch-item').forEach(s => {
                  s.classList.remove('active');
                  s.style.borderColor = 'transparent';
                  s.style.borderWidth = '3px';
                });
                swatch.classList.add('active');
                swatch.style.borderColor = '#000';
                swatch.style.borderWidth = '4px';
                // Update the text node (last child, after link icon if present)
                const textNodeIndex = parseInt(nameLabel.dataset.textNodeIndex || '0', 10);
                const textNode = nameLabel.childNodes[textNodeIndex];
                if (textNode && textNode.nodeType === Node.TEXT_NODE) {
                  const viewPrefix = stepView?.name ? `${stepView.name}: ` : '';
                  textNode.textContent = `${viewPrefix}${layer.name || 'Unnamed Layer'} (${color.name})`;
                } else {
                  // Fallback: update last text node
                  const textNodes = Array.from(nameLabel.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
                  if (textNodes.length > 0) {
                    const viewPrefix = stepView?.name ? `${stepView.name}: ` : '';
                    textNodes[textNodes.length - 1].textContent = `${viewPrefix}${layer.name || 'Unnamed Layer'} (${color.name})`;
                  }
                }
                updateNextButtonState();
                generateViewToggle();
              });
              
              colorGrid.appendChild(swatch);
            });
          }
          
          if (_pcIsOptional && isOptionalLayerHidden(stepView, layer)) {
            labelDiv.style.display = 'none';
            colorGrid.style.display = 'none';
          }
          layerDiv.appendChild(headerDiv);
          layerDiv.appendChild(labelDiv);
          layerDiv.appendChild(colorGrid);
          layersContent.appendChild(layerDiv);
        });
      }
      
      // Logo section
      if (!isStandardColorsStage() && currentView.logo.enabled !== false) {
        const logoSection = document.createElement('div');
        logoSection.className = 'pc-section';
        const logoHeader = document.createElement('div');
        logoHeader.className = 'pc-section-header';
        logoHeader.style.cssText = 'display: flex; align-items: center; gap: 8px;';
          logoHeader.innerHTML = '<h4 class="pc-heading">Logo</h4><span class="pc-info-icon" data-tooltip="Upload a clean logo: PNG, JPG, SVG, WebP, GIF, TIFF, HEIC, ICO, or BMP. Remove Background works best on solid-color backdrops (not typical for SVG)."><img src="https://cdn.shopify.com/s/files/1/1569/7559/files/icons8-info-50.png?v=1770298321" alt="Info" /></span>';
        logoSection.appendChild(logoHeader);
        const logoContent = document.createElement('div');
        logoContent.className = 'pc-section-content';
        logoContent.innerHTML = `
          <p style="margin:0 0 8px;font-size:0.85rem;color:#4b5563;">Tip: Upload your logo, then use <strong>Remove Background</strong> for best print-ready clarity.</p>
          <p style="margin:0 0 10px;font-size:0.85rem;color:#4b5563;">You can drag the logo on the bag to fine-tune its position (up to 50px in any direction).</p>
          <label class="pc-label">Upload Logo</label>
          <input type="file" id="pc-logo-upload" accept="${LOGO_IMAGE_ACCEPT}" class="pc-input" style="margin-bottom: 10px;">
          <div id="pc-logo-tools" style="display:none; gap: 10px; margin-bottom:10px; flex-wrap:wrap;">
            <button id="pc-remove-bg-btn" class="pc-btn-sm" type="button">Remove Background (Optional)</button>
            <button id="pc-reset-logo-btn" class="pc-btn-sm" type="button">Reset</button>
          </div>
          <button id="pc-remove-logo-btn" style="color:red; background:none; border:none; cursor:pointer; display:none; margin-bottom:10px;">Remove Logo</button>
          <div id="pc-logo-preview"></div>
          <div style="margin-top: 10px;">
            <label class="pc-label-sm">Logo Size</label>
            <input type="range" id="pc-logo-size" min="50" max="300" value="${currentView.logo.size || 150}" class="pc-range-input">
          </div>
        `;
        logoSection.appendChild(logoContent);
        controlsContainer.appendChild(logoSection);
        
        const logoUpload = logoSection.querySelector('#pc-logo-upload');
        const logoTools = logoSection.querySelector('#pc-logo-tools');
        const removeLogoBtn = logoSection.querySelector('#pc-remove-logo-btn');
        const removeBgBtn = logoSection.querySelector('#pc-remove-bg-btn');
        const resetLogoBtn = logoSection.querySelector('#pc-reset-logo-btn');
        const logoSizeInput = logoSection.querySelector('#pc-logo-size');
        
        logoUpload.addEventListener('change', (e) => {
          const file = e.target.files[0];
          if (file) {
            if (!isAllowedLogoImageFile(file)) {
              showToast('Please choose a supported image (PNG, JPG, SVG, WebP, GIF, TIFF, HEIC, etc.)');
              e.target.value = '';
              return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {
              currentView.elements.logo.active = true;
              currentView.elements.logo.src = event.target.result;
              currentView.elements.logo.originalSrc = event.target.result;
              logoTools.style.display = 'flex';
              removeLogoBtn.style.display = 'inline-block';
              generateLogos();
              updateNextButtonState();
              generateViewToggle();
            };
            reader.readAsDataURL(file);
          }
        });
        
        if (removeLogoBtn) {
          removeLogoBtn.addEventListener('click', () => {
            currentView.elements.logo.active = false;
            currentView.elements.logo.src = null;
            currentView.elements.logo.originalSrc = null;
            logoTools.style.display = 'none';
            removeLogoBtn.style.display = 'none';
            logoUpload.value = '';
            generateLogos();
            updateNextButtonState();
            generateViewToggle();
          });
        }
        
        if (logoSizeInput) {
          logoSizeInput.addEventListener('input', (e) => {
            currentView.elements.logo.size = parseInt(e.target.value, 10);
            generateLogos();
          });
        }
        
        if (removeBgBtn) {
          removeBgBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            if (!currentView.elements.logo.active || !currentView.elements.logo.src) return;
            removeBgBtn.textContent = 'Processing...';
            removeBgBtn.disabled = true;
            try {
              await removeOuterBackground(currentView.elements.logo.src, (newSrc) => {
                currentView.elements.logo.src = newSrc;
                generateLogos();
                removeBgBtn.textContent = 'Remove Background';
                removeBgBtn.disabled = false;
                updateNextButtonState();
              });
            } catch (err) {
              console.error('Background removal failed:', err);
              removeBgBtn.textContent = 'Remove Background';
              removeBgBtn.disabled = false;
            }
          });
        }
        
        if (resetLogoBtn) {
          resetLogoBtn.addEventListener('click', () => {
            if (currentView.elements.logo.originalSrc) {
              currentView.elements.logo.src = currentView.elements.logo.originalSrc;
              generateLogos();
            }
          });
        }
      }
      
      // Text sections
      if (!isStandardColorsStage()) [currentView.text1, currentView.text2].forEach((textConfig, idx) => {
        const textNum = idx + 1;
        if (textConfig.enabled === false) return;
        const lockContent = isTextContentLocked(textConfig);
        const requiresPaidOptIn = shouldRequirePaidTextOptIn(textConfig);
        const paidOptIn = requiresPaidOptIn ? ensurePaidTextOptInState(currentView, textNum) : true;
        if (lockContent) {
          const lockedValue = getLockedTextValue(textConfig);
          currentView.elements[`text${textNum}`].content = lockedValue;
          currentView.elements[`text${textNum}`].active = String(lockedValue).trim() !== '';
        }
        
        const textSection = document.createElement('div');
        textSection.className = 'pc-section';
        const effectiveColor = (textConfig.linkedLayerId && currentView.parts[textConfig.linkedLayerId]) ? currentView.parts[textConfig.linkedLayerId] : (currentView.elements[`text${textNum}`].color || textConfig.defaultColor);
        let colorOptionsHTML = '';
        BRAND_COLORS.forEach(color => {
          const selected = (effectiveColor && color.hex.toUpperCase() === effectiveColor.toUpperCase()) ? ' selected' : '';
          colorOptionsHTML += `<option value="${color.hex}"${selected}>${color.name}</option>`;
        });
        const colorDisabled = textConfig.linkedLayerId ? ' disabled title="Color linked to layer"' : '';
        const readonlyAttr = lockContent ? ' readonly title="This text is fixed by admin"' : '';
        const textDisabledAttr = requiresPaidOptIn && !paidOptIn ? ' disabled' : '';
        const paidOptInHTML = requiresPaidOptIn ? `
          <label class="pc-label" style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
            <input type="checkbox" id="pc-text-${textNum}-paid-optin" ${paidOptIn ? 'checked' : ''}>
            <span>Add customisation for $12</span>
          </label>
        ` : '';
        const textInputHTML = lockContent ? '' : `
          ${paidOptInHTML}
          <label class="pc-label">Text Content</label>
          <input type="text" id="pc-text-${textNum}-input" class="pc-input" placeholder="${textConfig.placeholder || 'Enter text...'}" value="${currentView.elements[`text${textNum}`].content || ''}"${readonlyAttr}${textDisabledAttr}>
        `;
        
        const textHeader = document.createElement('div');
        textHeader.className = 'pc-section-header';
        textHeader.style.cssText = 'display: flex; align-items: center; gap: 8px;';
        textHeader.innerHTML = `<h4 class="pc-heading">Text ${textNum}</h4><span class="pc-info-icon" data-tooltip="Enter custom text to personalize your design. You can change the color and adjust the size using the controls below."><img src="https://cdn.shopify.com/s/files/1/1569/7559/files/icons8-info-50.png?v=1770298321" alt="Info" /></span>`;
        textSection.appendChild(textHeader);
        // If this text is linked to a layer, show the layer-style swatches (same palette as layer colors).
        const linkedLayer = textConfig.linkedLayerId ? (currentView.layers || []).find(l => l.id === textConfig.linkedLayerId) : null;
        const linkedLayerName = linkedLayer?.name ? String(linkedLayer.name) : 'layer';
        let linkedLayerSwatchesHTML = '';
        if (textConfig.linkedLayerId) {
          const currentHex = (effectiveColor || '').toString().toUpperCase();
          linkedLayerSwatchesHTML = `
            <div class="pc-label" style="margin-top:8px;">Color (linked to ${linkedLayerName})</div>
            <div class="pc-color-grid" data-linked-layer-id="${textConfig.linkedLayerId}" style="margin-top:8px; width:100%;">
              ${BRAND_COLORS.map((c) => {
                const isActive = currentHex && c.hex.toUpperCase() === currentHex;
                const borderWidth = isActive ? '4px' : '3px';
                const borderColor = isActive ? '#000' : 'transparent';
                return `<div class="pc-color-swatch-item${isActive ? ' active' : ''}" data-color-hex="${c.hex}" title="${c.name} (${c.hex})" style="aspect-ratio:1;border-radius:0;border:${borderWidth} solid ${borderColor};cursor:pointer;transition:all 0.2s ease;min-height:44px;min-width:44px;width:100%;height:auto;box-shadow:0 2px 4px rgba(0,0,0,0.1);background-color:${c.hex};display:block;"></div>`;
              }).join('')}
            </div>
            <div class="pc-help" style="margin:6px 0 10px;color:#6b7280;font-size:0.85rem;">This picker controls the linked layer color for this view.</div>
          `;
        }

        const textContent = document.createElement('div');
        textContent.className = 'pc-section-content';
        textContent.innerHTML = `
          <p style="margin:0 0 8px;font-size:0.85rem;color:#4b5563;">Text ${textNum} is optional. Enter exactly what you want printed and choose a color/size for readability.</p>
          ${textInputHTML}
          ${textConfig.linkedLayerId ? linkedLayerSwatchesHTML : `
            <label class="pc-label">Color</label>
            <select id="pc-text-${textNum}-color" class="pc-select" style="height:46px;">
            ${colorOptionsHTML}
          </select>
          `}
          <div style="margin-top: 10px;">
            <label class="pc-label-sm">Text Size</label>
            <input type="range"
              id="pc-text-${textNum}-size"
              min="${(textConfig.sizeMin != null ? textConfig.sizeMin : 1)}"
              max="${(textConfig.sizeMax != null ? textConfig.sizeMax : 5)}"
              step="0.1"
              value="${currentView.elements[`text${textNum}`].size || textConfig.sizeDefault || textConfig.size || 2}"
              class="pc-range-input">
          </div>
        `;
        textSection.appendChild(textContent);
        controlsContainer.appendChild(textSection);
        
        const textInput = textSection.querySelector(`#pc-text-${textNum}-input`);
        const colorSelect = textSection.querySelector(`#pc-text-${textNum}-color`);
        const sizeInput = textSection.querySelector(`#pc-text-${textNum}-size`);
        const paidOptInInput = textSection.querySelector(`#pc-text-${textNum}-paid-optin`);
        const linkedSwatchGrid = textSection.querySelector(`.pc-color-grid[data-linked-layer-id="${textConfig.linkedLayerId || ''}"]`);

        if (paidOptInInput) {
          paidOptInInput.addEventListener('change', (e) => {
            currentView.elements[`text${textNum}`].paidOptIn = !!e.target.checked;
            if (!enforcePurchaseBagPaidOptInLimit(e.target, currentView, textNum)) {
              return;
            }
            if (!e.target.checked) {
              currentView.elements[`text${textNum}`].active = false;
              currentView.elements[`text${textNum}`].content = '';
            }
            generateControls();
            generateTexts();
            updateNextButtonState();
            generateViewToggle();
          });
        }
        
        if (textInput) {
        textInput.addEventListener('input', (e) => {
            if (lockContent) return;
            if (requiresPaidOptIn && !currentView.elements[`text${textNum}`].paidOptIn) return;
          if (textConfig.enabled !== false) {
            currentView.elements[`text${textNum}`].active = e.target.value.length > 0;
            currentView.elements[`text${textNum}`].content = e.target.value;
            generateTexts();
            updateNextButtonState();
            generateViewToggle();
          }
        });
        }
        
        if (colorSelect) {
        colorSelect.addEventListener('change', (e) => {
            const next = e.target.value;
            currentView.elements[`text${textNum}`].color = next;
            // Keep any layers linked TO this text in sync, and recolor a linked layer if set.
            syncLayersLinkedToTextColors(currentView);
            if (textConfig.linkedLayerId) {
              updateLayerColor(textConfig.linkedLayerId, next);
            }
          generateTexts();
          updateNextButtonState();
        });
        }
        
        if (linkedSwatchGrid && textConfig.linkedLayerId) {
          linkedSwatchGrid.querySelectorAll('.pc-color-swatch-item').forEach((swatch) => {
            swatch.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const next = swatch.getAttribute('data-color-hex');
              if (!next) return;
              currentView.elements[`text${textNum}`].color = next;
              updateLayerColor(textConfig.linkedLayerId, next);
              generateControls();
              generateTexts();
              updateNextButtonState();
            });
          });
        }
        
        sizeInput.addEventListener('input', (e) => {
          currentView.elements[`text${textNum}`].size = parseFloat(e.target.value);
          generateTexts();
          updateNextButtonState();
        });
      });
      
      // Logo or Text section (desktop)
      if (!isStandardColorsStage() && currentView.logoOrText && currentView.logoOrText.enabled) {
        const lotConfig = currentView.logoOrText;
        const lotState = currentView.elements.logoOrText;
        const mode = (lotState && lotState.mode) || 'text';
        const lotSection = document.createElement('div');
        lotSection.className = 'pc-section';
        lotSection.innerHTML = '<div class="pc-section-header" style="display:flex;align-items:center;gap:8px;"><h4 class="pc-heading">Logo or Text</h4></div>';
        const toggleWrap = document.createElement('div');
        toggleWrap.style.cssText = 'margin-bottom:12px; display:flex; gap:8px;';
        const btnLogo = document.createElement('button');
        btnLogo.type = 'button';
        btnLogo.className = 'pc-btn-sm' + (mode === 'logo' ? ' pc-btn-primary' : '');
        btnLogo.textContent = 'Logo';
        const btnText = document.createElement('button');
        btnText.type = 'button';
        btnText.className = 'pc-btn-sm' + (mode === 'text' ? ' pc-btn-primary' : '');
        btnText.textContent = 'Text';
        btnLogo.addEventListener('click', () => {
          currentView.elements.logoOrText.mode = 'logo';
          generateControls();
          generateLogos();
          generateTexts();
          updateNextButtonState();
        });
        btnText.addEventListener('click', () => {
          currentView.elements.logoOrText.mode = 'text';
          generateControls();
          generateLogos();
          generateTexts();
          updateNextButtonState();
        });
        toggleWrap.appendChild(btnLogo);
        toggleWrap.appendChild(btnText);
        lotSection.appendChild(toggleWrap);
        const lotContent = document.createElement('div');
        lotContent.className = 'pc-section-content';
        if (mode === 'logo') {
          lotContent.innerHTML = `
            <label class="pc-label">Upload Logo</label>
            <input type="file" id="pc-lot-logo-upload" accept="${LOGO_IMAGE_ACCEPT}" class="pc-input" style="margin-bottom:10px;">
            <button id="pc-lot-remove-logo" style="color:red;background:none;border:none;cursor:pointer;display:none;margin-bottom:10px;">Remove Logo</button>
            <div style="margin-top:10px;"><label class="pc-label-sm">Logo Size (px)</label><input type="range" id="pc-lot-logo-size" min="50" max="300" value="${(lotState && lotState.logoSize != null) ? lotState.logoSize : (lotConfig.sizeLogo ?? 150)}" class="pc-range-input"></div>
          `;
          lotSection.appendChild(lotContent);
          controlsContainer.appendChild(lotSection);
          const upload = lotContent.querySelector('#pc-lot-logo-upload');
          const removeBtn = lotContent.querySelector('#pc-lot-remove-logo');
          const sizeInput = lotContent.querySelector('#pc-lot-logo-size');
          if (upload) upload.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (file) {
              if (!isAllowedLogoImageFile(file)) {
                showToast('Please choose a supported image (PNG, JPG, SVG, WebP, GIF, TIFF, HEIC, etc.)');
                e.target.value = '';
                return;
              }
              const reader = new FileReader();
              reader.onload = (ev) => {
                currentView.elements.logoOrText.logo = { active: true, src: ev.target.result, originalSrc: ev.target.result };
                if (removeBtn) removeBtn.style.display = 'inline-block';
                generateLogos();
                updateNextButtonState();
                generateViewToggle();
              };
              reader.readAsDataURL(file);
            }
          });
          if (removeBtn) removeBtn.addEventListener('click', () => {
            currentView.elements.logoOrText.logo = { active: false, src: null, originalSrc: null };
            if (removeBtn) removeBtn.style.display = 'none';
            if (upload) upload.value = '';
            generateLogos();
            updateNextButtonState();
            generateViewToggle();
          });
          if (sizeInput) sizeInput.addEventListener('input', (e) => {
            currentView.elements.logoOrText.logoSize = parseInt(e.target.value, 10);
            generateLogos();
          });
        } else {
          const effectiveColor = (lotConfig.linkedLayerId && currentView.parts[lotConfig.linkedLayerId]) ? currentView.parts[lotConfig.linkedLayerId] : (lotState.color || lotConfig.defaultColor || '#363636');
          let colorOpts = '';
          BRAND_COLORS.forEach(c => { colorOpts += `<option value="${c.hex}"${(c.hex.toUpperCase() === effectiveColor.toUpperCase()) ? ' selected' : ''}>${c.name}</option>`; });
          lotContent.innerHTML = `
            <label class="pc-label">Text Content</label>
            <input type="text" id="pc-lot-text-input" class="pc-input" placeholder="${lotConfig.placeholder || 'Logo or text...'}" value="${(lotState && lotState.content) || ''}">
            <label class="pc-label">Color${lotConfig.linkedLayerId ? ' (linked to layer)' : ''}</label>
            <select id="pc-lot-color" class="pc-select" style="height:46px;" ${lotConfig.linkedLayerId ? 'disabled' : ''}>${colorOpts}</select>
          <div style="margin-top:10px;"><label class="pc-label-sm">Text Size (rem)</label><input type="range" id="pc-lot-text-size" min="${lotConfig.sizeTextMin ?? 1}" max="${lotConfig.sizeTextMax ?? 5}" step="0.1" value="${(lotState && lotState.size != null) ? lotState.size : (lotConfig.sizeTextDefault ?? lotConfig.sizeText ?? 2)}" class="pc-range-input"></div>
          `;
          lotSection.appendChild(lotContent);
          controlsContainer.appendChild(lotSection);
          const textInput = lotContent.querySelector('#pc-lot-text-input');
          const colorSelect = lotContent.querySelector('#pc-lot-color');
          const textSizeInput = lotContent.querySelector('#pc-lot-text-size');
          if (textInput) textInput.addEventListener('input', (e) => {
            currentView.elements.logoOrText.content = e.target.value;
            generateTexts();
            updateNextButtonState();
            generateViewToggle();
          });
          if (colorSelect && !lotConfig.linkedLayerId) colorSelect.addEventListener('change', (e) => {
            currentView.elements.logoOrText.color = e.target.value;
            generateTexts();
              syncLayersLinkedToTextColors(currentView);
          });
          if (textSizeInput) textSizeInput.addEventListener('input', (e) => {
            currentView.elements.logoOrText.size = parseFloat(e.target.value);
            generateTexts();
            updateNextButtonState();
          });
        }
      }
    }
    
    // Position tooltips after controls are generated
    setTimeout(() => positionTooltips(), 100);
    // Apply mobile-friendly input behavior (Cleave + inputmode) to customizer inputs
    setTimeout(() => initMobileFriendlyInputs(), 150);
  }

  function initMobileFriendlyInputs() {
    const modal = document.getElementById('pc-customizer-modal');
    if (!modal) return;
    const root = modal;
    const isMobile = window.innerWidth < 768;
    
    // All text/number/tel/email inputs and selects in modal (form + customizer)
    root.querySelectorAll('.pc-input, .pc-select, .pc-textarea, input.pc-input, select.pc-select, textarea.pc-textarea').forEach(el => {
      if (el.tagName === 'SELECT') {
        if (isMobile && !el.hasAttribute('data-mobile-friendly')) {
          el.setAttribute('data-mobile-friendly', 'true');
        }
        return;
      }
      if (el.type === 'file' || el.type === 'hidden' || el.type === 'range') return;
      
      if (isMobile) {
        if (!el.hasAttribute('inputmode')) {
          if (el.type === 'tel') el.setAttribute('inputmode', 'tel');
          else if (el.type === 'number' || el.name === 'Quantity') el.setAttribute('inputmode', 'numeric');
          else if (el.type === 'email') el.setAttribute('inputmode', 'email');
          else el.setAttribute('inputmode', 'text');
        }
        el.setAttribute('data-mobile-friendly', 'true');
      }
    });
    
    // Cleave.js: phone
    if (typeof Cleave !== 'undefined') {
      const phoneInput = root.querySelector('input[name="Phone"], input[type="tel"]');
      if (phoneInput && !phoneInput.dataset.cleaveInitialized) {
        try {
          new Cleave(phoneInput, { phone: true, phoneRegionCode: 'US' });
          phoneInput.dataset.cleaveInitialized = 'true';
        } catch (e) {}
      }
      // Quantity: numeral (integers only)
      const qtyInput = root.querySelector('input[name="Quantity"]');
      if (qtyInput && !qtyInput.dataset.cleaveInitialized) {
        try {
          new Cleave(qtyInput, { numeral: true, numeralIntegerScale: 6, numeralPositiveOnly: true });
          qtyInput.dataset.cleaveInitialized = 'true';
        } catch (e) {}
      }
    }
  }
  window.initMobileFriendlyInputs = initMobileFriendlyInputs;

  function initFilters() {
    if (!svgFilters) return;
    svgFilters.innerHTML = '';
    const currentView = state.views[state.currentViewIndex];
    
    if (!currentView || !currentView.layers) return;
    
    // Create the special white-enhance filter (shared across all layers for white)
    const whiteEnhanceFilter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
    whiteEnhanceFilter.setAttribute('id', 'f-white-enhance');
    whiteEnhanceFilter.setAttribute('color-interpolation-filters', 'sRGB');
    
    const whiteColorMatrix = document.createElementNS('http://www.w3.org/2000/svg', 'feColorMatrix');
    whiteColorMatrix.setAttribute('type', 'saturate');
    whiteColorMatrix.setAttribute('values', '0');
    whiteColorMatrix.setAttribute('in', 'SourceGraphic');
    whiteColorMatrix.setAttribute('result', 'grayscale');
    
    const whiteComponentTransfer = document.createElementNS('http://www.w3.org/2000/svg', 'feComponentTransfer');
    whiteComponentTransfer.setAttribute('in', 'grayscale');
    whiteComponentTransfer.setAttribute('result', 'brightened');
    
    const whiteFuncR = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncR');
    whiteFuncR.setAttribute('type', 'linear');
    whiteFuncR.setAttribute('slope', '2.4');
    whiteFuncR.setAttribute('intercept', '-0.3');
    
    const whiteFuncG = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncG');
    whiteFuncG.setAttribute('type', 'linear');
    whiteFuncG.setAttribute('slope', '2.4');
    whiteFuncG.setAttribute('intercept', '-0.3');
    
    const whiteFuncB = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncB');
    whiteFuncB.setAttribute('type', 'linear');
    whiteFuncB.setAttribute('slope', '2.4');
    whiteFuncB.setAttribute('intercept', '-0.3');
    
    whiteComponentTransfer.appendChild(whiteFuncR);
    whiteComponentTransfer.appendChild(whiteFuncG);
    whiteComponentTransfer.appendChild(whiteFuncB);
    
    whiteEnhanceFilter.appendChild(whiteColorMatrix);
    whiteEnhanceFilter.appendChild(whiteComponentTransfer);
    svgFilters.appendChild(whiteEnhanceFilter);
    
    // Create filters for each layer
    currentView.layers.forEach(layer => {
      if (isOptionalLayerHidden(currentView, layer)) return;
      // Ensure parts object has this layer initialized
      if (!currentView.parts.hasOwnProperty(layer.id)) {
        currentView.parts[layer.id] = getLayerInitialColor(layer);
      }
      
      const currentColor = (currentView.parts[layer.id] || getLayerBaseColor(layer)).toUpperCase();
      const filterId = `f-${currentView.id}-${layer.id}`;
      const floodId = `flood-${currentView.id}-${layer.id}`;
      
      // For white, we'll use the special white-enhance filter, so skip creating standard filter
      if (currentColor === '#FFFFFF') {
        const img = document.getElementById(`layer-${currentView.id}-${layer.id}`);
        if (img) {
          img.style.filter = 'url(#f-white-enhance) drop-shadow(0 2px 5px rgba(0,0,0,0.3))';
        }
        return; // Skip creating standard filter for white
      }
      
      const brightColorNames = ['Gold', 'Orange', 'Vegas Gold', 'Columbia', 'Silver Gray'];
      const currentColorObj = BRAND_COLORS.find(c => c.hex.toUpperCase() === currentColor);
      const isBrightColor = currentColorObj && brightColorNames.includes(currentColorObj.name);
      
      const filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
      filter.setAttribute('id', filterId);
      filter.setAttribute('color-interpolation-filters', 'sRGB');
      
      const colorMatrix = document.createElementNS('http://www.w3.org/2000/svg', 'feColorMatrix');
      colorMatrix.setAttribute('type', 'saturate');
      colorMatrix.setAttribute('values', '0');
      colorMatrix.setAttribute('in', 'SourceGraphic');
      colorMatrix.setAttribute('result', 'grayscale');
      
      filter.appendChild(colorMatrix);
      
      if (isBrightColor) {
        const componentTransfer = document.createElementNS('http://www.w3.org/2000/svg', 'feComponentTransfer');
        componentTransfer.setAttribute('in', 'grayscale');
        componentTransfer.setAttribute('result', 'brightened');
        const funcR = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncR');
        funcR.setAttribute('type', 'linear');
        funcR.setAttribute('slope', '1.8');
        funcR.setAttribute('intercept', '-0.1');
        const funcG = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncG');
        funcG.setAttribute('type', 'linear');
        funcG.setAttribute('slope', '1.8');
        funcG.setAttribute('intercept', '-0.1');
        const funcB = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncB');
        funcB.setAttribute('type', 'linear');
        funcB.setAttribute('slope', '1.8');
        funcB.setAttribute('intercept', '-0.1');
        componentTransfer.appendChild(funcR);
        componentTransfer.appendChild(funcG);
        componentTransfer.appendChild(funcB);
        filter.appendChild(componentTransfer);
      }
      
      const flood = document.createElementNS('http://www.w3.org/2000/svg', 'feFlood');
      flood.setAttribute('flood-color', currentColor);
      flood.setAttribute('result', 'color');
      flood.setAttribute('id', floodId);
      
      const composite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite');
      composite.setAttribute('in', 'color');
      composite.setAttribute('in2', 'SourceAlpha');
      composite.setAttribute('operator', 'in');
      composite.setAttribute('result', 'maskedColor');
      
      const blend = document.createElementNS('http://www.w3.org/2000/svg', 'feBlend');
      blend.setAttribute('mode', 'multiply');
      blend.setAttribute('in', 'maskedColor');
      blend.setAttribute('in2', isBrightColor ? 'brightened' : 'grayscale');
      
      filter.appendChild(flood);
      filter.appendChild(composite);
      filter.appendChild(blend);
      svgFilters.appendChild(filter);
      
      // Ensure the layer image has the filter applied
      const img = document.getElementById(`layer-${currentView.id}-${layer.id}`);
      if (img) {
        img.style.filter = `url(#${filterId})`;
      }
    });
  }

  function updateLayerColor(layerId, color) {
    const currentView = state.views[state.currentViewIndex];
    const currentLayer = currentView.layers.find(l => l.id === layerId);
    if (!currentLayer) return;

    // Check if this layer is linked to another layer (layer-to-layer link)
    if (currentLayer.linkedLayerId) {
      const [targetViewId, targetLayerId] = currentLayer.linkedLayerId.split(':');
      const targetView = state.views.find(v => v.id === targetViewId);
      const targetLayer = targetView?.layers?.find(l => l.id === targetLayerId);
      
      if (targetView && targetLayer) {
        // Update the target layer's color (source of truth)
        targetView.parts[targetLayerId] = color;
        updateLayerVisuals(targetView.id, targetLayerId, color);
        
        // Find the target layer's index for view-level syncing
        const targetLayerIndex = targetView.layers.findIndex(l => l.id === targetLayerId);
        
        // Sync to all layers that link to this target layer (layer-to-layer links)
        state.views.forEach((v) => {
          v.layers.forEach((l) => {
            if (l.linkedLayerId === `${targetViewId}:${targetLayerId}`) {
              v.parts[l.id] = color;
              updateLayerVisuals(v.id, l.id, color);
            }
          });
        });
        
        // CRITICAL: Sync to all views that are view-level linked to the TARGET view
        // This creates cascading: if View 1 and View 2 are linked, and View 3's layer links to View 1,
        // then View 2's corresponding layer should also update
        if (targetLayerIndex >= 0) {
          state.views.forEach((v) => {
            if (v.linkedToViewId === targetView.id && v.layers[targetLayerIndex]) {
              v.parts[v.layers[targetLayerIndex].id] = color;
              updateLayerVisuals(v.id, v.layers[targetLayerIndex].id, color);
            }
          });
        }
        
        // Update the current layer's visual
        updateLayerVisuals(currentView.id, layerId, color);
        
        // Sync linked text colors
        syncLinkedTextColors(layerId, color);
        syncLinkedTextColors(targetLayerId, color); // Also sync text linked to target layer
        
        // Final sync pass to ensure all linked layers are updated
        syncLinkedViewParts();
        
        generateTexts();
        generateLogos();
        generateControls(); // Regenerate controls to show updated colors
        return;
      }
    }

    // Original logic: view-level linking or independent layer
    const layerIndex = currentView.layers.findIndex(l => l.id === layerId);
    if (layerIndex < 0) return;

    // Resolve source view: if this view links to another, that view is the source; else this view is the source
    const sourceViewIndex = currentView.linkedToViewId
      ? state.views.findIndex(v => v.id === currentView.linkedToViewId)
      : state.currentViewIndex;
    if (sourceViewIndex < 0) return;
    const sourceView = state.views[sourceViewIndex];
    const sourceLayerId = sourceView.layers[layerIndex]?.id;
    if (!sourceLayerId) return;

    // Update source view's part
    sourceView.parts[sourceLayerId] = color;
    updateLayerVisuals(sourceView.id, sourceLayerId, color);
    
    // Sync to all views that link to this source (by layer index) - view-level linking
    state.views.forEach((v) => {
      if (v.linkedToViewId !== sourceView.id) return;
      const linkedLayer = v.layers[layerIndex];
      if (linkedLayer) {
        v.parts[linkedLayer.id] = color;
        updateLayerVisuals(v.id, linkedLayer.id, color);
      }
    });
    
    // CRITICAL: Sync all layers that link to this specific layer (layer-to-layer reverse lookup)
    // This handles: if View 1's Bag End changes, View 3's Bag End (which links to View 1's Bag End) should update
    state.views.forEach((v) => {
      v.layers.forEach((l) => {
        if (l.linkedLayerId === `${sourceView.id}:${sourceLayerId}`) {
          v.parts[l.id] = color;
          updateLayerVisuals(v.id, l.id, color);
        }
      });
    });
    
    // CASCADE: If source view has view-level linked views, also sync layers that link to those views' layers
    // Example: View 1 ↔ View 2 (linked), View 3's layer links to View 1's layer
    // When View 1's layer changes, View 2's corresponding layer should also update
    state.views.forEach((v) => {
      if (v.linkedToViewId === sourceView.id) {
        const linkedLayer = v.layers[layerIndex];
        if (linkedLayer) {
          // Find all layers that link to this linked view's layer
          state.views.forEach((otherView) => {
            otherView.layers.forEach((otherLayer) => {
              if (otherLayer.linkedLayerId === `${v.id}:${linkedLayer.id}`) {
                otherView.parts[otherLayer.id] = color;
                updateLayerVisuals(otherView.id, otherLayer.id, color);
              }
            });
          });
        }
      }
    });

    // Update visual for current layer
    updateLayerVisuals(currentView.id, layerId, color);
    
    // Sync linked text colors: any text slot with linkedLayerId === this layer gets the new color
    syncLinkedTextColors(layerId, color);
    syncLinkedTextColors(sourceLayerId, color); // Also sync text linked to source layer
    
    // Final sync pass to ensure all linked layers are updated
    syncLinkedViewParts();
    
    generateTexts();
    generateLogos();
    generateControls(); // Regenerate controls to show updated colors
  }

  // Helper function to update layer visual filters
  function updateLayerVisuals(viewId, layerId, color) {
    const colorUpper = color.toUpperCase();
    const img = document.getElementById(`layer-${viewId}-${layerId}`);
    
    if (!img) return;
    
    // Handle white special case - use white-enhance filter
    if (colorUpper === '#FFFFFF') {
      img.style.filter = 'url(#f-white-enhance) drop-shadow(0 2px 5px rgba(0,0,0,0.3))';
      return;
    }
    
    // For non-white colors, use standard filter
    const filterId = `f-${viewId}-${layerId}`;
    const floodId = `flood-${viewId}-${layerId}`;
    const floodElement = document.getElementById(floodId);
    
    if (floodElement) {
      // Update the flood color directly
      floodElement.setAttribute('flood-color', color);
      img.style.filter = `url(#${filterId})`;
    } else {
      // If filter doesn't exist, regenerate all filters
      initFilters();
    }
  }

  // Purchase-bag helper: keeps layer colors locked to variant body color + black rest.
  function applyPurchaseBagLockedLayerColors(bodyHex, { updateCurrentView = true, refreshControls = true } = {}) {
    if (!isPurchaseBag) return;
    const targetBodyHex = (bodyHex || PURCHASE_BAG_BLACK_HEX).toString();

    state.views.forEach((view) => {
      if (!view?.layers?.length) return;

      const bodyLayer = view.layers[0];
      if (bodyLayer?.id) {
        view.layers[0].defaultColor = targetBodyHex;
        view.parts[bodyLayer.id] = targetBodyHex;
      }

      view.layers.forEach((layer, idx) => {
        if (!layer?.id) return;
        if (idx === 0) return;
        const lockedColor = getPurchaseBagLockedLayerColor(layer, idx, targetBodyHex);
        layer.defaultColor = lockedColor;
        view.parts[layer.id] = lockedColor;
      });
    });

    if (!updateCurrentView) return;

    const currentView = state.views[state.currentViewIndex];
    if (!currentView) return;

    (currentView.layers || []).forEach((layer, idx) => {
      const color = getPurchaseBagLockedLayerColor(layer, idx, targetBodyHex);
      updateLayerVisuals(currentView.id, layer.id, color);
    });

    // Refresh text rendering (text may be linked to layer colors).
    generateTexts();

    // Optionally refresh the UI (e.g., linked text color selectors / labels).
    if (refreshControls) {
      generateControls();
    }
    updateNextButtonState();
  }

  // Helper function to sync linked text colors
  function syncLinkedTextColors(layerId, color) {
    state.views.forEach((view) => {
      if (view.elements.text1 && view.text1 && view.text1.linkedLayerId === layerId) {
        view.elements.text1.color = color;
      }
      if (view.elements.text2 && view.text2 && view.text2.linkedLayerId === layerId) {
        view.elements.text2.color = color;
      }
      if (view.elements.logoOrText && view.logoOrText && view.logoOrText.linkedLayerId === layerId) {
        view.elements.logoOrText.color = color;
      }
    });
  }

  // Function to ensure canvas maintains square aspect ratio on mobile
  function ensureSquareCanvas() {
    if (!canvasContainer) return;
    const isMobile = false; /* let CSS control canvas size on all screens (fixes oversized mobile canvas) */
    if (!isMobile) {
      // On desktop, let CSS handle it - remove all inline styles
      canvasContainer.style.width = '';
      canvasContainer.style.height = '';
      canvasContainer.style.maxWidth = '';
      canvasContainer.style.maxHeight = '';
      canvasContainer.style.minWidth = '';
      canvasContainer.style.minHeight = '';
      return;
    }
    
    // On mobile, calculate square size based on available space
    const viewArea = canvasContainer.parentElement;
    if (!viewArea) return;
    
    const viewAreaRect = viewArea.getBoundingClientRect();
    // Account for padding more accurately
    const computedStyle = window.getComputedStyle(viewArea);
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const availableWidth = viewAreaRect.width - paddingLeft - paddingRight;
    const availableHeight = viewAreaRect.height - paddingTop - paddingBottom;
    
    // Use the smaller dimension to ensure square fits, but ensure minimum size for bag visibility
    const squareSize = Math.max(200, Math.min(availableWidth, availableHeight));
    
    // Set explicit dimensions to override any CSS constraints
    canvasContainer.style.width = squareSize + 'px';
    canvasContainer.style.height = squareSize + 'px';
    canvasContainer.style.maxWidth = squareSize + 'px';
    canvasContainer.style.maxHeight = squareSize + 'px';
    canvasContainer.style.minWidth = squareSize + 'px';
    canvasContainer.style.minHeight = squareSize + 'px';
    const r = canvasContainer.getBoundingClientRect();
    const v = state.views[state.currentViewIndex];
    if (v && r.width > 0 && r.height > 0) {
      v.previewCanvasWidth = r.width;
      v.previewCanvasHeight = r.height;
    }
  }

  function switchView(index) {
    // Ensure square canvas on mobile when switching views
    ensureSquareCanvas();
    // Lock desktop/mobile canvas to builder aspect
    ensureAspectCanvasForCurrentView();
    state.currentViewIndex = index;
    // Reset mobile customization step when switching views
    if (window.innerWidth < 768) {
      state.mobileLayerStep = 0;
      state.mobileCustomizationStep = 0;
    }
    // Sync linked colors before generating UI to ensure correct colors are displayed
    syncLinkedViewParts();
    generateViewToggle();
    generateLayers(); // This will also call initFilters() at the end
    generateLogos();
    generateTexts();
    generateControls(); // This generates the color swatches
    updateNextButtonState();
    updateViewNavButtons();
    syncDesktopHeaderOffsets();
  }

  function loadSavedDesign() {
    try {
      const saved = localStorage.getItem('pc_save_' + window.pcProductInfo.id);
      if (saved) {
        const savedState = JSON.parse(saved);
        if (savedState.views && savedState.views.length === state.views.length) {
          // Merge saved customizations (colors, logo, text) with fresh layer structure from API
          // This ensures layer names and structure are always up-to-date from backend
          state.views = state.views.map((currentView, viewIdx) => {
            const savedView = savedState.views[viewIdx];
            if (!savedView) return currentView;
            
            // Merge: Keep current view structure (with fresh layer names from API)
            // but restore user customizations (colors, logo, text)
            return {
              ...currentView, // Fresh structure from API (includes updated layer names)
              parts: savedView.parts || currentView.parts || currentView.layers.reduce((acc, layer) => {
                acc[layer.id] = getLayerInitialColor(layer);
                return acc;
              }, {}),
              optionalLayersHidden: (savedView.optionalLayersHidden && typeof savedView.optionalLayersHidden === 'object')
                ? { ...savedView.optionalLayersHidden }
                : (currentView.optionalLayersHidden || {}),
              elements: {
                logo: savedView.elements?.logo || currentView.elements.logo,
                text1: savedView.elements?.text1 || currentView.elements.text1,
                text2: savedView.elements?.text2 || currentView.elements.text2,
                logoOrText: savedView.elements?.logoOrText || currentView.elements.logoOrText
              }
            };
          });
          syncLinkedViewParts();
          switchView(state.currentViewIndex);
        }
      }
    } catch (err) {
      console.error('Error loading saved design', err);
    }
  }

  function setupEventListeners() {
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.remove('active');
        document.body.classList.remove('pc-modal-open');
      });
    }

    // Keep desktop step content aligned below the sticky header across zoom/viewport changes.
    syncDesktopHeaderOffsets();
    window.addEventListener('resize', syncDesktopHeaderOffsets);

    if (viewPrevBtn) {
      viewPrevBtn.addEventListener('click', () => {
        if (state.currentViewIndex > 0) switchView(state.currentViewIndex - 1);
      });
    }
    if (viewNextBtn) {
      viewNextBtn.addEventListener('click', () => {
        if (state.currentViewIndex < state.views.length - 1) switchView(state.currentViewIndex + 1);
      });
    }

    if (journeyProgressEl) {
      journeyProgressEl.addEventListener('click', (event) => {
        const target = event.target?.closest?.('[data-journey-step]');
        if (!target) return;
        const stepKey = target.getAttribute('data-journey-step');
        goToStandardJourneyStep(stepKey);
      });
    }

    // Purchase-bag: recolor bag body instantly when the shopper switches variants
    if (isPurchaseBag && typeof subscribe === 'function') {
      const variantEventName = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.variantChange)
        ? PUB_SUB_EVENTS.variantChange
        : 'variant-change';

      subscribe(variantEventName, (event) => {
        if (!modal?.classList?.contains('active')) return;

        const variant = event?.data?.variant || event?.variant;
        const nextHex = getPurchaseBagBodyHexFromVariant(variant);
        applyPurchaseBagLockedLayerColors(nextHex, { updateCurrentView: true, refreshControls: false });
      });
    }

    if (toStep2Btn) {
      toStep2Btn.addEventListener('click', () => {
        if (isStandardColorsStage()) {
        const isMobile = false; /* mobile step-walk disabled: all controls shown in the scrolling panel */
        if (isMobile && typeof window.updateMobileCustomizationStep === 'function') {
            const colorSteps = buildStandardColorSteps();
            if (colorSteps.length > 0 && state.mobileCustomizationStep < colorSteps.length - 1) {
              state.mobileCustomizationStep++;
              window.updateMobileCustomizationStep();
              updateNextButtonState();
              return;
            }
          }

          state.standardJourneyStage = 'customize';
          state.currentViewIndex = 0;
          state.mobileCustomizationStep = 0;
          switchView(0);
          if (controlsAreaEl) controlsAreaEl.scrollTop = 0;
          updateNextButtonState();
          return;
        }

        const isMobile = false; /* mobile step-walk disabled: all controls shown in the scrolling panel */
        
        // Mobile: Cycle through customization steps within current view
        if (isMobile && typeof window.updateMobileCustomizationStep === 'function') {
          const currentView = state.views[state.currentViewIndex];
          const steps = buildCustomizationStepsForView(currentView);
          
          // If there are more steps in current view, advance to next step
          if (state.mobileCustomizationStep !== undefined && state.mobileCustomizationStep < steps.length - 1) {
            state.mobileCustomizationStep++;
            window.updateMobileCustomizationStep();
            return;
          }
        }
        
        // Desktop or all customization complete
        if (isPurchaseBag) {
          addToCartFromPurchaseBag();
          return;
        }
        
        // Otherwise proceed to quote form
        const warningMsg = document.getElementById('pc-completion-warning');
        if (warningMsg) {
          warningMsg.style.display = 'none';
        }
        
        const card = document.querySelector('.pc-card');
        if (card) {
          card.classList.add('step-2-active');
        }
        
        step1.classList.add('hidden-step');
        setTimeout(() => {
          step1.style.display = 'none';
          step2.style.display = 'block';
          step2.scrollTop = 0;
          setTimeout(() => {
            step2.classList.remove('hidden-step');
            initMobileFriendlyInputs();
            renderJourneyProgress();
            startQuoteAssetPreflight();
          }, 10);
        }, 300);
      });
    }
    
    // Back button handler for mobile step navigation
    if (backStepMobileBtn) {
      backStepMobileBtn.addEventListener('click', () => {
        if (!isPurchaseBag && !isStandardColorsStage() && window.innerWidth >= 768) {
          goToStandardJourneyStep('colors');
          return;
        }

        if (isStandardColorsStage()) return;

        const isMobile = window.innerWidth < 768;
        
        if (isMobile && typeof window.updateMobileCustomizationStep === 'function') {
          const currentView = state.views[state.currentViewIndex];
          const steps = buildCustomizationStepsForView(currentView);
          
          // If we're not on first step of current view, go back one step
          if (state.mobileCustomizationStep !== undefined && state.mobileCustomizationStep > 0) {
            state.mobileCustomizationStep--;
            window.updateMobileCustomizationStep();
            updateNextButtonState();
            return;
          }
        }
      });
    }
    
    if (backToStep1Btn) {
      backToStep1Btn.addEventListener('click', () => {
        invalidateQuotePreflight();
        // Remove class from card to restore Step 1 layout
        const card = document.querySelector('.pc-card');
        if (card) {
          card.classList.remove('step-2-active');
        }
        
        step2.classList.add('hidden-step');
        setTimeout(() => {
          step2.style.display = 'none';
          step1.style.display = 'flex';
          setTimeout(() => {
            step1.classList.remove('hidden-step');
            if (controlsAreaEl) controlsAreaEl.scrollTop = 0;
            renderJourneyProgress();
          }, 10);
        }, 300);
      });
    }

    const saveHandler = () => {
      try {
        localStorage.setItem('pc_save_' + window.pcProductInfo.id, JSON.stringify(state));
        showToast('Design saved successfully');
      } catch(e) {
        showToast('Could not save design. Images might be too large.');
        console.error(e);
      }
    };
    
    if (saveBtn) saveBtn.addEventListener('click', saveHandler);
    if (saveBtnMobile) saveBtnMobile.addEventListener('click', saveHandler);

    const resetHandler = () => {
      if (confirm('Are you sure you want to reset your design? This will clear all customizations.')) {
        state.views.forEach((view) => {
          view.optionalLayersHidden = {};
          view.layers.forEach(layer => {
            view.parts[layer.id] = getLayerInitialColor(layer);
          });
          view.elements.logo = {
            active: false,
            src: null,
            originalSrc: null,
            size: view.logo.size
          };
          view.elements.text1 = {
            active: false,
            content: '',
            color: '#FFFFFF',
            size: view.text1.size
          };
          view.elements.text2 = {
            active: false,
            content: '',
            color: '#FFFFFF',
            size: view.text2.size
          };
          view.elements.logoOrText = {
            mode: 'text',
            content: '',
            color: (view.logoOrText && view.logoOrText.defaultColor) || '#363636',
            size: (view.logoOrText && view.logoOrText.sizeText != null) ? view.logoOrText.sizeText : 2,
            logoSize: null,
            logo: { active: false, src: null, originalSrc: null }
          };
          enforceLockedTextContent(view);
        });
        try {
          localStorage.removeItem('pc_save_' + window.pcProductInfo.id);
        } catch(e) {
          console.error('Error clearing saved state:', e);
        }
        switchView(state.currentViewIndex);
        showToast('Design reset successfully');
      }
    };
    
    if (resetDesignBtn) resetDesignBtn.addEventListener('click', resetHandler);
    if (resetDesignBtnMobile) resetDesignBtnMobile.addEventListener('click', resetHandler);

    const downloadBtns = [downloadViewsBtn, document.getElementById('pc-download-views-btn-desktop')].filter(Boolean);
    const runDownload = async () => {
        showToast('Preparing your designs for download…');
        const apiBase = (config.apiEndpoint || window.pcConfig?.apiEndpoint || '').replace(/\/api\/custom-quote\/?$/, '');
        const downloadEndpoint = apiBase ? apiBase + '/api/customizer-render-download' : '';
        if (!downloadEndpoint) {
          showToast('Download endpoint not configured');
          return;
        }
        assignPreviewCanvasMetricsToAllViews();
        const customizationData = buildCustomizationDataForQuoteApi();
        const activeBtn = downloadViewsBtn || document.getElementById('pc-download-views-btn-desktop');
        const originalTitle = activeBtn ? activeBtn.getAttribute('title') : 'Download all views';
        downloadBtns.forEach(btn => { btn.setAttribute('title', 'Preparing...'); btn.classList.add('pc-loading'); btn.disabled = true; });
        try {
          const response = await fetch(downloadEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              customization: customizationData,
              customizerId: window.pcConfig?.customiserId || null
            })
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            showToast(data.error || 'Download failed');
            return;
          }
          if (!data.images || data.images.length === 0) {
            showToast('No images were generated');
            return;
          }
          data.images.forEach((img, i) => {
            setTimeout(() => {
              const a = document.createElement('a');
              a.href = img.base64;
              a.download = (img.viewName || 'view-' + (i + 1)) + '.jpg';
              a.rel = 'noopener';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }, i * 400);
          });
          showToast('Download started for ' + data.images.length + ' view(s)');
        } catch (err) {
          console.error('Download error:', err);
          showToast('Download failed');
        } finally {
          downloadBtns.forEach(btn => { btn.setAttribute('title', originalTitle); btn.classList.remove('pc-loading'); btn.disabled = false; });
        }
    };
    downloadBtns.forEach(btn => btn.addEventListener('click', runDownload));

    if (quoteForm) {
      quoteForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (isPurchaseBag) {
          // Purchase-bag flow submits directly to Shopify, not via the quote endpoint.
          return;
        }
        const btnText = submitBtn.querySelector('.pc-btn-text');
        submitBtn.classList.add('pc-btn-loading');
        submitBtn.disabled = true;

        const formData = new FormData(quoteForm);
        const customerDetails = {};
        formData.forEach((value, key) => { customerDetails[key] = value; });

        try {
          btnText.textContent = 'Submitting...';
          
          assignPreviewCanvasMetricsToAllViews();
          if (quotePreflightState.promise) {
            try {
              await quotePreflightState.promise;
            } catch (_) { /* preflight optional */ }
          }
          const customizationData = buildCustomizationDataForQuoteApi();
          const customizationJson = JSON.stringify(customizationData);
          let preflightPayload = null;
          if (
            quotePreflightState.customizationJson === customizationJson &&
            quotePreflightPreviewsComplete(quotePreflightState.previews, views)
          ) {
            preflightPayload = {
              previews: quotePreflightState.previews,
              logos: quotePreflightState.logos || {}
            };
          }

          const customizationForSubmit = preflightPayload
            ? slimCustomizationPayloadForPreflightSubmit(customizationData, preflightPayload)
            : customizationData;

          const payload = {
            product: window.pcProductInfo,
            customer: customerDetails,
            customization: customizationForSubmit,
            customizerId: window.pcConfig?.customiserId || null,
            ...(preflightPayload ? { preflight: preflightPayload } : {})
          };

          console.log(`[Client] Submitting customization data for ${customizationData.views.length} views`);

          const response = await fetch(config.apiEndpoint || window.pcConfig.apiEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
          });

          if (response.ok) {
            const responseData = await response.json().catch(() => ({}));
            console.log(`[Client] Success response:`, responseData);
            quoteForm.reset();
            modal.classList.remove('active');
            document.body.classList.remove('pc-modal-open');
            const thankYou = (window.pcConfig && window.pcConfig.quoteThankYouUrl) ? String(window.pcConfig.quoteThankYouUrl).trim() : '';
            if (thankYou) {
              // Normalize thank-you URL for theme preview / iframe contexts:
              // - If thankYou is absolute (shop.url), keep navigation on the current origin by converting to a relative path.
              let finalThankYou = thankYou;
              let normalizedVia = null;
              try {
                const isAbsolute = /^https?:\/\//i.test(finalThankYou);
                if (isAbsolute) {
                  const u = new URL(finalThankYou);
                  finalThankYou = (u.pathname || '/') + (u.search || '') + (u.hash || '');
                  normalizedVia = 'absolute_to_relative';
                }
              } catch (err) {
                normalizedVia = 'normalize_failed';
              }
              const inIframe = (() => { try { return window.top && window.top !== window; } catch (_) { return true; } })();
              try {
                const targetLocation = inIframe && window.top && window.top.location ? window.top.location : window.location;
                targetLocation.assign(finalThankYou);
              } catch (_) {
                window.location.assign(finalThankYou);
              }
              return;
            }
            showToast('Your quote request has been sent successfully!');
          } else {
            const errorText = await response.text();
            console.error(`[Client] Server Error (${response.status}):`, errorText);
            let errorData;
            try {
              errorData = JSON.parse(errorText);
              console.error("[Client] Parsed error:", errorData);
            } catch (e) {
              console.error("[Client] Error response is not JSON:", errorText);
            }
            showToast('Failed to send request. Please check the console for details.');
          }
        } catch (networkError) {
          console.error("Network Error:", networkError);
          showToast('Network error. Please check your connection and try again.');
        } finally {
          submitBtn.classList.remove('pc-btn-loading');
          submitBtn.disabled = false;
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('active')) return;
      
      if (e.key === 'Escape') {
        modal.classList.remove('active');
        document.body.classList.remove('pc-modal-open');
      }
    });
    
    // Resize handler to regenerate logos and texts with proper scaling
    let resizeTimeout;
    // Function to ensure canvas maintains square aspect ratio on mobile
    window.addEventListener('resize', () => {
      if (!modal.classList.contains('active')) return;
      
      // Ensure square canvas on mobile
      ensureSquareCanvas();
      
      // Debounce resize events
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        generateLogos();
        generateTexts();
      }, 150);
    });
    
    // Ensure square canvas on initial load
    if (modal.classList.contains('active')) {
      setTimeout(() => {
        ensureSquareCanvas();
        generateLogos();
        generateTexts();
      }, 100);
    }
  }

  // =========================================================
  // Purchase-bag: Add-to-cart + line-item properties
  // =========================================================
  async function addToCartFromPurchaseBag() {
    if (!isPurchaseBag) return;

    const formId = window.pcPurchaseBagProductFormId;
    const customizationInputId = window.pcPurchaseBagPropCustomizationId;
    const uploadsInputId = window.pcPurchaseBagPropUploadsId;
    const previewsInputId = window.pcPurchaseBagPropPreviewsId;
    const letteringCountInputId = window.pcPurchaseBagPropLetteringCountId;

    const form = formId ? document.getElementById(formId) : null;
    const customizationInput = customizationInputId ? document.getElementById(customizationInputId) : null;
    const uploadsInput = uploadsInputId ? document.getElementById(uploadsInputId) : null;
    const previewsInput = previewsInputId ? document.getElementById(previewsInputId) : null;
    const letteringCountInput = letteringCountInputId ? document.getElementById(letteringCountInputId) : null;


    if (!form || !customizationInput || !uploadsInput) {
      showToast('Could not submit purchase bag. Missing form or property fields.');
      return;
    }

    const currentVariantInput = form.querySelector('input[name="id"]') || form.querySelector('.product-variant-id');
    const currentVariantId = currentVariantInput?.value || String(window.pcProductInfo?.variant_id || '');

    const originalToStep2Text = toStep2Btn?.textContent || 'Add to cart';
    if (toStep2Btn) {
      toStep2Btn.disabled = true;
      toStep2Btn.textContent = 'Adding to cart...';
    }

    try {
      // 1) Upload active logos/assets to get URLs for line-item properties
      const uploadBase = String(window.pcConfig?.customizerApiUrl || 'https://rogue-wear-shopify-quote-api-v4.vercel.app').replace(/\/$/, '');
      const uploadEndpoint = `${uploadBase}/api/customizer-upload-order-assets`;
      const includePreviews = window.pcConfig?.purchaseBagIncludePreviews === true;
      const uploadFetchStartedAt = Date.now();

      assignPreviewCanvasMetricsToAllViews();
      const uploadPayload = {
        viewportMobileScale: getViewportMobileScaleForApi(),
        views: views.map((view, idx) => {
          const viewState = state.views[idx];
          return {
            id: view.id,
            name: view.name,
            flipLayers: view.flipLayers,
            builderCanvasWidth: viewState.builderCanvasWidth ?? view.builderCanvasWidth,
            builderCanvasHeight: viewState.builderCanvasHeight ?? view.builderCanvasHeight,
            previewCanvasWidth: viewState.previewCanvasWidth,
            previewCanvasHeight: viewState.previewCanvasHeight,
            optionalLayersHidden: viewState.optionalLayersHidden || {},
            layers: view.layers.map((layer) => ({
              id: layer.id,
              name: layer.name,
              image: layer.image,
              zIndex: layer.zIndex,
              defaultColor: layer.defaultColor,
              optional: layer.optional === true
            })),
            logo: view.logo,
            text1: view.text1,
            text2: view.text2,
            logoOrText: view.logoOrText || null,
            parts: viewState.parts,
            elements: {
              logo: viewState.elements.logo,
              text1: viewState.elements.text1,
              text2: viewState.elements.text2,
              logoOrText: viewState.elements.logoOrText || null
            }
          };
        })
      };

      const uploadResp = await fetch(uploadEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          customization: uploadPayload,
          customizerId: window.pcConfig?.customiserId || null,
          includePreviews
        })
      });

      const uploadData = await uploadResp.json().catch(() => ({}));
      if (!uploadResp.ok) {
        throw new Error(uploadData?.error || 'Upload failed');
      }

      const uploads = uploadData?.uploads || {};
      const previews = uploadData?.previews || {};

      // 2) Build order line-item properties (only text + logo URLs)
      // Keep these values short so they don't expose full configuration/layer data.
      const textsByView = {};
      const logosByView = {};
      let letteringCountPerBag = 0;

      state.views.forEach((viewState) => {
        const viewName = viewState?.name || viewState?.id || 'view';
        if (!viewName) return;

        const entry = {};

        const text1Config = viewState.text1 || null;
        const text2Config = viewState.text2 || null;
        const text1Content = viewState.elements?.text1?.content || '';
        const text2Content = viewState.elements?.text2?.content || '';

        if (text1Config && text1Config.enabled !== false && String(text1Content).trim() !== '') {
          entry.text1 = text1Content;
        }
        if (text2Config && text2Config.enabled !== false && String(text2Content).trim() !== '') {
          entry.text2 = text2Content;
        }

        if (shouldRequirePaidTextOptIn(text1Config) && viewState.elements?.text1?.paidOptIn === true) {
          letteringCountPerBag += 1;
        }
        if (shouldRequirePaidTextOptIn(text2Config) && viewState.elements?.text2?.paidOptIn === true) {
          letteringCountPerBag += 1;
        }

        // logoOrText can be either an uploaded logo or a free text (mode === 'text')
        const lotConfig = viewState.logoOrText || null;
        const lotState = viewState.elements?.logoOrText || null;
        if (lotConfig && lotConfig.enabled && lotState?.mode === 'text' && String(lotState?.content || '').trim() !== '') {
          entry.logoOrTextText = lotState.content;
        }

        if (Object.keys(entry).length) {
          textsByView[viewName] = entry;
        }

        // Logo URLs come back from the upload endpoint keyed by viewState.id
        const uploadForView = uploads?.[viewState.id];
        const logoUrl = uploadForView?.logo || uploadForView?.logoOrText;
        if (logoUrl) {
          logosByView[viewName] = logoUrl;
        }
      });

      customizationInput.value = JSON.stringify({ textsByView });
      uploadsInput.value = JSON.stringify({ logosByView });
      if (previewsInput) {
        previewsInput.value = JSON.stringify({ previewsByView: previews });
      }
      const maxLetteringFees = getPurchaseBagMaxLetteringFees();
      letteringCountPerBag = Math.min(letteringCountPerBag, maxLetteringFees);
      if (letteringCountInput) letteringCountInput.value = String(letteringCountPerBag);

      // 3) Add bag + fee tier to cart through AJAX (non-Plus compatible)
      modal?.classList?.remove('active');
      document.body.classList.remove('pc-modal-open');
      const quantityInput = form.querySelector('input[name="quantity"]');
      const bagQuantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
      const feeVariantId = letteringCountPerBag > 0 ? getPurchaseBagFeeVariantId(letteringCountPerBag) : null;
      const feeGroupId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

      const bagProperties = {
        _PurchaseBagCustomization: customizationInput.value || '',
        _PurchaseBagUploads: uploadsInput.value || '',
        _PurchaseBagPreviews: previewsInput?.value || '',
        PurchaseBagLetteringCountPerBag: String(letteringCountPerBag),
        _PurchaseBagFeeGroupId: feeGroupId
      };
      const items = [{
        id: Number(currentVariantId),
        quantity: bagQuantity,
        properties: bagProperties
      }];

      if (letteringCountPerBag > 0) {
        if (!feeVariantId) {
          throw new Error(`Missing fee variant mapping for lettering count ${letteringCountPerBag}`);
        }
        items.push({
          id: feeVariantId,
          quantity: bagQuantity,
          properties: {
            _PurchaseBagFeeForGroupId: feeGroupId,
            _PurchaseBagFeeTier: String(letteringCountPerBag)
          }
        });
      }

      const cartAddResp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });
      const cartAddData = await cartAddResp.json().catch(() => ({}));
      if (!cartAddResp.ok) {
        throw new Error(cartAddData?.description || cartAddData?.message || 'Cart add failed');
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error('[PurchaseBag] addToCart failed:', err);
      showToast('Failed to add to cart. Please try again.');

      if (toStep2Btn) {
        toStep2Btn.disabled = false;
        toStep2Btn.textContent = originalToStep2Text;
      }
    }
  }

  function showToast(message) {
    const toast = document.createElement('div');
    toast.className = 'pc-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 500);
    }, 3000);
  }

  // Logo background removal function
  function removeOuterBackground(imgSrc, callback) {
    if (!imgSrc) {
      callback(null);
      return;
    }
    
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = imgSrc;
    
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      const w = canvas.width;
      const h = canvas.height;
      
      // Get corner pixel color (top-left)
      const rT = data[0], gT = data[1], bT = data[2], aT = data[3];
      const tol = 50;
      const visited = new Uint8Array(w * h);
      const stack = [[0,0], [w-1, 0], [0, h-1], [w-1, h-1]];
      
      const match = (idx) => {
        const r = data[idx], g = data[idx+1], b = data[idx+2], a = data[idx+3];
        if (a === 0) return true;
        const dist = Math.sqrt((r-rT)**2 + (g-gT)**2 + (b-bT)**2);
        return dist <= tol;
      };

      // Flood fill from corners
      while(stack.length) {
        const [x, y] = stack.pop();
        if(x < 0 || x >= w || y < 0 || y >= h) continue;
        
        const pixIdx = y * w + x;
        if(visited[pixIdx]) continue;
        visited[pixIdx] = 1;
        const dataIdx = pixIdx * 4;
        
        if(match(dataIdx)) {
          data[dataIdx+3] = 0; // Make transparent
          stack.push([x+1, y], [x-1, y], [x, y+1], [x, y-1]);
        }
      }
      
      ctx.putImageData(imageData, 0, 0);

      // Crop to content bounding box so image center = content center (fixes logo position)
      const ALPHA_THRESHOLD = 10;
      let minX = w, minY = h, maxX = -1, maxY = -1;
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          const a = data[(y * w + x) * 4 + 3];
          if (a >= ALPHA_THRESHOLD) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      let resultCanvas = canvas;
      if (minX <= maxX && minY <= maxY) {
        const pad = 1;
        const x = Math.max(0, minX - pad);
        const y = Math.max(0, minY - pad);
        const cw = Math.min(w - x, maxX - x + 1 + pad * 2);
        const ch = Math.min(h - y, maxY - y + 1 + pad * 2);
        if (cw >= 1 && ch >= 1) {
          resultCanvas = document.createElement('canvas');
          resultCanvas.width = cw;
          resultCanvas.height = ch;
          const rCtx = resultCanvas.getContext('2d');
          rCtx.drawImage(canvas, x, y, cw, ch, 0, 0, cw, ch);
        }
      }
      callback(resultCanvas.toDataURL());
    };
    
    img.onerror = () => {
      console.error('Failed to load image for background removal');
      callback(null);
    };
  }

  // Setup button click listener
  // Get button reference again in case it wasn't found initially
  const buttonForListener = inlineBtn || document.getElementById('pc-trigger-btn-inline');
  if (buttonForListener && modal) {
    buttonForListener.addEventListener('click', async (e) => {
      e.preventDefault();
      if (isPurchaseBag) {
        const ctx = getCurrentPurchaseBagVariantContext();
      }
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.classList.add('active');
      // Ensure square canvas on mobile after modal opens
      setTimeout(() => {
        ensureSquareCanvas();
        syncDesktopHeaderOffsets();
      }, 50);
      document.body.classList.add('pc-modal-open');
      if (isPurchaseBagMode && configFetchPromise) {
        try { await configFetchPromise; } catch (err) {}
        rebuildStateViewsFromLoadedConfig();
      }
      init();
    });
  } else {
    // Listener couldn't be attached (missing button or modal).
  }
  
  // Also prevent loading button from being clicked (it's just visual)
  if (loadingBtn) {
    loadingBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  setupEventListeners();
});
} catch(error) {
  console.error('Customizer Builder Error:', error);
  console.error('Error stack:', error.stack);
  // Even if there's an error, try to show the button if we have a customiser_id
  const config = window.pcConfig || {};
  if (config.customiserId) {
    setTimeout(() => {
      const loadingBtn = document.getElementById('pc-trigger-btn-loading');
      const inlineBtn = document.getElementById('pc-trigger-btn-inline');
      if (loadingBtn) loadingBtn.style.display = 'none';
      if (inlineBtn) {
        inlineBtn.style.display = 'block';
      }
    }, 500);
  } else {
    // Hide loading button if no customiser_id
    const loadingBtn = document.getElementById('pc-trigger-btn-loading');
    if (loadingBtn) loadingBtn.style.display = 'none';
  }
}

// Load Cleave.js for phone/numeral formatting (form + customizer)
(function() {
  if (typeof Cleave === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/cleave.js@1.6.0/dist/cleave.min.js';
    script.onload = function() {
      if (typeof initMobileFriendlyInputs === 'function') {
        const modal = document.getElementById('pc-customizer-modal');
        if (modal && modal.classList.contains('active')) initMobileFriendlyInputs();
      }
    };
    document.head.appendChild(script);
  }
})();
